import {
  CANCELLATION_REASONS_CTA,
  ConsultMode,
  CouponCategoryApplicable,
  DEVICETYPE,
  DEVICE_TYPE,
  DIAGNOSTICS_GROUPPLAN,
  DIAGNOSTIC_ORDER_STATUS,
  GENDER,
  PLAN,
  MEDICINE_ORDER_STATUS,
  ButtonTypes,
} from "graphql/types/globalTypes";
import {
  DiagnosticInclusions,
  TestObservation,
  fullTestDetailData,
} from "components/Tests/TestDetails";
import {
  GetDoctorDetailsById_getDoctorDetailsById as DoctorDetailsById,
  GetDoctorDetailsById_getDoctorDetailsById_consultHours,
} from "graphql/types/GetDoctorDetailsById";
import {
  GET_WIDGETS_PAGE_KEYS,
  getWidgetUrlForDiagnosticListingPage,
} from "strings/CmsUrlConfig";
import {
  IncObservationData,
  InclusionData,
} from "components/Tests/Cards/HotSellers";
import {
  CTA_CONFIG_EXPIRY,
  MINIMUM_AGE_FOR_DIAGNOSTIC_ORDER,
  PROHEALTH_DEFAULT_CITY,
  diagnosticPricingPackages,
  genericData,
} from "strings/AppConfig";
import {
  MedicineProduct,
  MedicineProductDetails,
} from "helpers/MedicineApiCalls";
import {
  add,
  addMinutes,
  differenceInMinutes,
  format,
  isAfter,
  set,
  setHours,
  setMinutes,
  subMinutes,
} from "date-fns";
import { useEffect, useState } from "react";

import { GetPatientAllAppointments_getPatientAllAppointments_appointments_caseSheet as CaseSheetType } from "graphql/types/GetPatientAllAppointments";
import { GetPatientByMobileNumber_getPatientByMobileNumber_patients as CurrentPatient } from "graphql/types/GetPatientByMobileNumber";
import { DiagnosticAddressByPinCode } from "components/interfaces/DiagnosticAddressByPinCode";
import { getUserNotifyEvents_getUserNotifyEvents_phr_newRecordsCount } from "graphql/types/getUserNotifyEvents";

import { DiagnosticWidgetInclusion } from "components/Tests/TestsLanding";
import { DiagnosticsCartItem } from "components/interfaces/DiagnosticsCartItem";
import { DoctorDetails } from "components/Doctors/SpecialtyDetails";
import { GooglePlacesType } from "components/LocationProvider";
import { LineItems } from "components/types/LineItems";
import { ModifyOrderIdAndItemIds } from "components/types/ModifyOrderIdAndItemIds";
import { getProHealthLocationCoordinates_getLocationCoordinates_coordinates as ProhealthCoordinates } from "graphql/types/getProHealthLocationCoordinates";
import { WHATSAPP_CHAT_LINK } from "helpers/constants";
import _get from "lodash/get";
import _lowerCase from "lodash/lowerCase";
import _unescape from "lodash/unescape";
import _upperFirst from "lodash/upperFirst";
import axios from "axios";
import { clientRoutes } from "helpers/clientRoutes";
import differenceInDays from "date-fns/differenceInDays";
import differenceInMonths from "date-fns/differenceInMonths";
import differenceInYears from "date-fns/differenceInYears";
import fetchUtil from "helpers/fetch";
import {
  flatten,
  InternalOrder,
  JuspayPaymentType,
} from "components/Juspay/helpers";
import parse from "date-fns/parse";
import { geocodeByAddress } from "react-places-autocomplete";
import {
  getLinkedProfilesPastConsultsAndPrescriptionsByMobile_getLinkedProfilesPastConsultsAndPrescriptionsByMobile_consults as pastConsultData,
  getLinkedProfilesPastConsultsAndPrescriptionsByMobileVariables as pastConsultVariables,
} from "graphql/types/getLinkedProfilesPastConsultsAndPrescriptionsByMobile";

import router from "next/router";
import { useDiagnosticsCart } from "components/Tests/DiagnosticsCartProvider";
import { GetRadiologyUnitsWithLatLong_getRadiologyUnitsWithLatLong as RadiologyUnitsWithCoords } from "graphql/types/GetRadiologyUnitsWithLatLong";
import { CartPageRespConfig } from "components/Tests/Cart/PatientCartItems";
import { GetPrimaryPatientsByMobileNumber_getPatientByMobileNumber_patient as PrimaryPatient } from "graphql/types/GetPrimaryPatientsByMobileNumber";
import { GetPatientByMobileNumber_getPatientByMobileNumber_patients as Patient } from "graphql/types/GetPatientByMobileNumber";
import clevertapTracking from "clevertapTracking";
import {
  SMBG_SECTION,
  SMBG_SECTION_POSITION,
} from "components/enums/SMBGSections";
import ApolloClient from "apollo-client";
import { UPLOAD_FILE } from "graphql/diagnostics";
import { UploadFile, UploadFileVariables } from "graphql/types/uploadFile";
interface Icons {
  pathName: string[];
  iconClass: string;
}

declare global {
  interface Window {
    opera: any;
    vendor: any;
    dataLayer: any;
  }
}
declare var teamsBusinessConsole: any;
interface paymentMethodInterface {
  [key: string]: string;
}

export const isBrowser = () => typeof window !== "undefined";

interface PharmaStateCodeMappingType {
  [key: string]: string;
}

export enum DOCTOR_CATEGORY {
  APOLLO = "APOLLO",
  PARTNER = "PARTNER",
}

export enum CACHE_KEYS {
  WIDGET_DATA = "WIDGET_DATA",
  POPULAR_TEST_SEARCH_DATA = "POPULAR_TEST_SEARCH_DATA",
  CATEGORY_LISTING_DATA = "CATEGORY_LISTING_DATA", // kept only for clearing existing keys, do not use
  GET_WIDGETS = "GET_WIDGETS", // use this for /getWidgets?page=Home
  GET_WIDGETS_DETAILS = "GET_WIDGETS_DETAILS", // use this for /getWidgets?page=Details
  GET_WIDGETS_CART = "GET_WIDGETS_CART", // use this for /getWidgets?page=Cart
  SEARCH_POPULAR_ITEMS = "SEARCH_POPULAR_ITEMS", // use this for /popular-test-search
  CARD_CONFIG_DATA = "CARD_CONFIG_DATA", // No city-wise config
  PROHEALTH_PAYMENT_CONFIG = "PROHEALTH_PAYMENT_CONFIG", // to display payment text on slot selection page
}

export const getCacheKeyForCityId = (
  cacheKey: CACHE_KEYS,
  cityId: number,
  page?: GET_WIDGETS_PAGE_KEYS
): CACHE_KEYS => {
  // remove old keys from localStorage to free up occupied space
  const oldKey = `${cacheKey}_${cityId}${
    page ? `_${page}`?.toUpperCase() : ""
  }`;
  if (localStorage?.getItem(oldKey)) {
    localStorage.removeItem(oldKey);
  }
  if (localStorage?.getItem(CACHE_KEYS.WIDGET_DATA)) {
    localStorage.removeItem(CACHE_KEYS.WIDGET_DATA);
  }

  // return new key
  switch (cacheKey) {
    case CACHE_KEYS.WIDGET_DATA:
      const newKey =
        !page || page === GET_WIDGETS_PAGE_KEYS.HOME
          ? CACHE_KEYS.GET_WIDGETS
          : page === GET_WIDGETS_PAGE_KEYS.DETAILS
          ? CACHE_KEYS.GET_WIDGETS_DETAILS
          : CACHE_KEYS.GET_WIDGETS_CART;
      return newKey;
    case CACHE_KEYS.POPULAR_TEST_SEARCH_DATA:
      return CACHE_KEYS.SEARCH_POPULAR_ITEMS;
    default:
      return cacheKey;
  }
};

export interface SearchObject {
  searchKeyword: string;
  experience: string[] | null;
  availability: string[] | null;
  fees: string[] | null;
  gender: string[] | null;
  language: string[] | null;
  dateSelected: string;
  specialtyName: string;
  prakticeSpecialties: string | null;
  consultMode: ConsultMode | null;
  doctorType: string[] | null;
  isCare?: boolean | null;
  facilityType?: string[] | null;
  superSpecialty?: string[] | null;
}
export interface DiagnosticPricing {
  allMrp: number;
  allPrice: number;
  circleMrp: number;
  circlePrice: number;
  couponDiscount?: number;
  actualMrp: number;
  actualAllPrice?: number;
  discountPercentage: number;
  groupPlan: DIAGNOSTICS_GROUPPLAN;
  isCircleDiscountGreater: boolean;
  nonCirclePlan: DIAGNOSTICS_GROUPPLAN;
  couponCode?: string;
  cashbackText: string;
  cashbackAmount: number;
  showDiscountPercent: boolean | null;
  showSlashedPrice: boolean;
}
export interface Range {
  [index: number]: {
    minimum: number;
    maximum: number;
  };
}
export interface FilterParams {
  experience: Range;
  availability: string[] | null;
  fees: Range;
  gender: string[] | null;
  language: string[] | null;
  consultMode: ConsultMode | null;
  doctorType: string[] | null;
  sort: string | null;
  availableNow: string;
  facilityType?: string[] | null;
  superSpecialty?: string[] | null;
}

declare var BusinessCenterContext: any;

const paymentMethodStrings: paymentMethodInterface = {
  DEBIT_CARD: "Debit Card",
  CREDIT_CARD: "Credit Card",
  NET_BANKING: "Net Banking",
  PAYTM_WALLET: "Paytm Wallet",
  CREDIT_CARD_EMI: "Credit Card EMI",
  UPI: "UPI",
  PAYTM_POSTPAID: "Paytm Postpaid",
  COD: "COD",
  EMI: "EMI",
};

const locationRoutesBlackList: string[] = [
  "/covid19",
  "/track-symptoms",
  "/terms",
  "/privacy",
  "/contact",
  "/my-account",
  "/health-records",
  "/address-book",
  "/aboutUs",
  "/appointments",
  "/appointmentslist",
  "/faq",
  "/needHelp",
  "/my-payments",
];

export const useDebounce = (value: any, delay: number) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Set debouncedValue to value (passed in) after the specified delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Return a cleanup function that will be called every time ...
      // ... useEffect is re-called. useEffect will only be re-called ...
      // ... if value changes
      return () => {
        clearTimeout(handler);
      };
    },
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value]
  );

  return debouncedValue;
};

const MEDICINE_QUANTITY: number = 20;

const sortByProperty = (arr: any[], property: string) =>
  arr.sort((a, b) => parseFloat(a[property]) - parseFloat(b[property]));

const getDeviceType = (): DEVICE_TYPE => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (!navigator || !navigator.userAgent) return;
  if (screen.width < 768) {
    //mobile
    return /Android/i.test(userAgent)
      ? DEVICE_TYPE.ANDROID
      : /iPhone/i.test(userAgent)
      ? DEVICE_TYPE.IOS
      : null;
  } else {
    return DEVICE_TYPE.DESKTOP;
  }
};

const getDeviceTypeTests = (): DEVICETYPE => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (!navigator || !navigator.userAgent) return;
  if (screen.width < 768) {
    //mobile
    return /Android/i.test(userAgent)
      ? DEVICETYPE.ANDROID
      : /iPhone/i.test(userAgent)
      ? DEVICETYPE.IOS
      : null;
  } else {
    return DEVICETYPE.DESKTOP;
  }
};

const getPaymentMethodFullName = (paymentMethodName: string) => {
  if (paymentMethodStrings[paymentMethodName])
    return paymentMethodStrings[paymentMethodName];
  return paymentMethodName || "Cashless";
};

const returnUserReadableDate = (isoDate: string) => {
  let date = new Date(isoDate);
  return date.toLocaleDateString("en-GB");
};

export const inputDataInfo = (data: any, excludeArray: string[]) => {
  let excluded: any = {};
  Object.keys(data).forEach((key) => {
    if (!excludeArray.includes(key)) {
      excluded[key] = data[key];
    }
  });
  return excluded;
};

export const getModifiedConsultOrderPhrMedsEventInfo = (data: any) => {
  data["Notes"] = data?.notes || null;
  data["Consult mode"] = data?.consultType || null;
  data["Doctor ID"] = data?.doctorId || null;
  data["Doctor type"] = data?.doctorType || null;
  data["Mobile number"] = data?.mobileNumber || null;
  data["Relation"] = data?.relation || null;
  data["Gender"] = data?.gender || null;
  data["Patient UHID"] = data?.uhid || null;
  data["Date of birth"] = data?.dateOfBirth || null;

  delete data?.notes;
  delete data?.consultType;
  delete data?.doctorId;
  delete data?.doctorType;
  delete data?.mobileNumber;
  delete data?.relation;
  delete data?.gender;
  delete data?.uhid;
  delete data?.dateOfBirth;
  delete data?.isConsulted;

  return {
    ...data,
  };
};

const getMembershipObject = (endDate: any, typeofPurchase: string) => {
  const t = new Date().toISOString();
  const b = new Date(endDate);
  const diffDays = differenceInDays(b, new Date(t));
  let userAttributes = {
    isCircleMember: endDate ? true : false,
    duration: "",
    startDate: endDate ? new Date().toLocaleDateString() : "",
    endDate: endDate ? returnUserReadableDate(endDate) : "",
  };
  let obj = {
    "Membership End Date": returnUserReadableDate(endDate),
    "Mobile Number": localStorage.getItem("mobile_num"),
    Type: typeofPurchase,
  };
  if (!endDate) {
    return obj;
  }
  if (diffDays > 50 && diffDays < 70) {
    userAttributes.duration = "60";
    return { ...obj, "Membership Type": "60 days", "Circle Plan Price": "49" };
  } else if (diffDays > 170 && diffDays < 190) {
    userAttributes.duration = "180";
    return {
      ...obj,
      "Membership Type": "180 days",
      "Circle Plan Price": "249",
    };
  } else if (diffDays > 350 && diffDays < 366) {
    userAttributes.duration = "360";
    return {
      ...obj,
      "Membership Type": "360 days",
      "Circle Plan Price": "349",
    };
  } else {
    return { ...obj, "Membership Type": "NA", "Circle Plan Price": "NA" };
  }
};

const pharmaStateCodeMapping: PharmaStateCodeMappingType = {
  "Andaman and Nicobar Islands": "AN",
  "Andhra Pradesh": "AP",
  "Arunachal Pradesh": "AR",
  Assam: "AS",
  Bihar: "BR",
  Chandigarh: "CH",
  Chhattisgarh: "CT",
  "Daman and Diu": "DD",
  Delhi: "DL",
  "Dadra and Nagar Haveli": "DN",
  Goa: "GA",
  Gujarat: "GJ",
  "Himachal Pradesh": "HP",
  Haryana: "HR",
  Jharkhand: "JH",
  "Jammu and Kashmir": "JK",
  Karnataka: "KA",
  Kerala: "KL",
  Lakshadweep: "LD",
  Maharashtra: "MH",
  Meghalaya: "ML",
  Manipur: "MN",
  "Madhya Pradesh": "MP",
  Mizoram: "MZ",
  Nagaland: "NL",
  Odisha: "OR",
  Punjab: "PB",
  Puducherry: "PY",
  Rajasthan: "RJ",
  Sikkim: "SK",
  "Tamil Nadu": "TN",
  Tripura: "TR",
  Telangana: "TS",
  "Uttar Pradesh": "UP",
  Uttarakhand: "UT",
  "West Bengal": "WB",
};

const customerCareNumber = "04048217222";
const kavachHelpline = "18605000202";

const readableParam = (param: string) => {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  const p = new RegExp(a.split("").join("|"), "g");
  if (param)
    return param
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
};

export const getTestListingCategorySlug = (itemTitle: string) =>
  itemTitle?.toLowerCase()?.replace(/\s+/g, "-");

const dayMapping = {
  MONDAY: "Mo",
  TUESDAY: "Tu",
  WEDNESDAY: "We",
  THURSDAY: "Th",
  FRIDAY: "Fr",
  SATURDAY: "SA",
  SUNDAY: "Su",
};

const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => reject(error);
  });

const acceptedFilesNamesForFileUpload = ["png", "jpg", "jpeg", "pdf"];
const MAX_FILE_SIZE_FOR_UPLOAD = 3000000;
const INVALID_FILE_SIZE_ERROR =
  "Invalid File Size. File size must be less than 3MB";
const INVALID_FILE_TYPE_ERROR =
  "Invalid File Extension. Only files with .jpg, .png or .pdf extensions are allowed.";
const SPECIAL_CHARACTER_IN_NAME_ERROR =
  "The file which is being uploaded has special characters in its name. Please rename to upload";
const acceptedPdfFileTypes = ["application/pdf"];
const acceptedImageFileTypes = ["image/png", "image/jpeg", "image/jpg"];
const acceptedFileTypes = [...acceptedPdfFileTypes, ...acceptedImageFileTypes];
export const isFiletypeAccepted = (file: File) => {
  return acceptedFileTypes.includes(file?.type);
};
export const isValidFileName = (name: string) => {
  //accepts file names with alphanumeric characters and underscores, hyphens, spaces, brackets
  return /^[a-z, A-Z\d\-_.()\s]+$/.test(name);
};
const NO_SERVICEABLE_MESSAGE = "Sorry, not serviceable in your area";
const OUT_OF_STOCK_MESSAGE = "Sorry, this item is out of stock in your area";
const OUT_OF_STOCK_PINCODE_SUBTEXT = "Item is Out Of Stock in your pincode";
const TAT_API_TIMEOUT_IN_MILLI_SEC = 20000; // in milli sec
const NO_ONLINE_SERVICE = "NOT AVAILABLE FOR ONLINE SALE";
const OUT_OF_STOCK = "Out Of Stock";
const NOTIFY_WHEN_IN_STOCK = "Notify when in stock";
const PINCODE_MAXLENGTH = 6;
const SPECIALTY_DETAIL_LISTING_PAGE_SIZE = 50;
const HOSPITAL_DETAIL_LISTING_PAGE_SIZE = 10;
const SPECIALTY_SEARCH_PAGE_SIZE = 20;

const findAddrComponents = (
  proptoFind: GooglePlacesType,
  addrComponents: {
    long_name: string;
    short_name: string;
    types: GooglePlacesType[];
  }[],
  state?: string
) => {
  const findItem = addrComponents.find(
    (item) => item.types.indexOf(proptoFind) > -1
  );
  return findItem
    ? state
      ? findItem.long_name || findItem.short_name
      : findItem.short_name || findItem.long_name
    : "";
};

const getTypeOfProduct = (type: string) => {
  switch (_lowerCase(type)) {
    case "pharma":
      return CouponCategoryApplicable.PHARMA;
    case "fmcg":
      return CouponCategoryApplicable.FMCG;
    default:
      return CouponCategoryApplicable.FMCG;
  }
};

const ORDER_BILLING_STATUS_STRINGS = {
  TOTAL_ORDER_BILLED: "Total Ordered Value",
  TOTAL_BILLED_VALUE: "Total Billed Value",
  COD_AMOUNT_TO_PAY: "COD amount to Pay",
  REFUND_TO_BE_INITIATED: "Refund to be initiated",
  AMOUNT_TO_BE_PAID_ON_DELIVERY: "Amount to be paid on delivery",
};

const getStatus = (status: MEDICINE_ORDER_STATUS) => {
  let statusString = "";
  switch (status) {
    case MEDICINE_ORDER_STATUS.CANCELLED:
      return "Order Cancelled";
    case MEDICINE_ORDER_STATUS.CANCEL_REQUEST:
      return "Cancel Requested";
    case MEDICINE_ORDER_STATUS.DELIVERED:
      return "Order Delivered";
    case MEDICINE_ORDER_STATUS.ITEMS_RETURNED:
      return "Items Returned";
    case MEDICINE_ORDER_STATUS.ORDER_INITIATED:
      return "Order Initiated";
    case MEDICINE_ORDER_STATUS.ORDER_BILLED:
      return "Order Billed and Packed";
    case MEDICINE_ORDER_STATUS.ORDER_CONFIRMED:
      return "Order Confirmed";
    case MEDICINE_ORDER_STATUS.ORDER_FAILED:
      return "Order Failed";
    case MEDICINE_ORDER_STATUS.ORDER_PLACED:
      return "Order Placed";
    case MEDICINE_ORDER_STATUS.ORDER_VERIFIED:
      return "Order Verified";
    case MEDICINE_ORDER_STATUS.OUT_FOR_DELIVERY:
      return "Order Dispatched";
    case MEDICINE_ORDER_STATUS.PAYMENT_FAILED:
      return "Payment Failed";
    case MEDICINE_ORDER_STATUS.PAYMENT_PENDING:
      return "Payment Pending";
    case MEDICINE_ORDER_STATUS.PAYMENT_SUCCESS:
      return "Payment Success";
    case MEDICINE_ORDER_STATUS.PICKEDUP:
      return "Order Picked Up";
    case MEDICINE_ORDER_STATUS.PRESCRIPTION_CART_READY:
      return "Prescription Cart Ready";
    case MEDICINE_ORDER_STATUS.PRESCRIPTION_UPLOADED:
      return "Prescription Uploaded";
    case MEDICINE_ORDER_STATUS.RETURN_ACCEPTED:
      return "Return Accepted";
    case MEDICINE_ORDER_STATUS.RETURN_INITIATED:
      return "Return Initiated";
    case MEDICINE_ORDER_STATUS.READY_AT_STORE:
      return "Ready At Store";
    case "TO_BE_DELIVERED" as any:
      return "Expected Order Delivery";
    default:
      statusString = status
        .split("_")
        .map(
          (item) =>
            `${item.slice(0, 1).toUpperCase()}${item.slice(1).toLowerCase()}`
        )
        .join(" ");
      return statusString;
  }
};

const isActualUser = () => {
  const botPattern =
    "(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
  const re = new RegExp(botPattern, "i");
  const userAgent = isWindow() && navigator.userAgent;
  return !re.test(userAgent);
};

const getStoreName = (storeAddress: string) => {
  const store = JSON.parse(storeAddress);
  return store && store.storename
    ? _upperFirst(_lowerCase(store.storename))
    : "";
};

const getPackOfMedicine = (medicineDetail: MedicineProductDetails) => {
  return `${medicineDetail.mou} ${
    medicineDetail.PharmaOverview && medicineDetail.PharmaOverview.length > 0
      ? medicineDetail.PharmaOverview[0].Doseform
      : ""
  }${medicineDetail.mou && parseFloat(medicineDetail.mou) !== 1 ? "S" : ""}`;
};

const getImageUrl = (imageUrl: string) => {
  return (
    imageUrl &&
    imageUrl
      .split(",")
      .filter((imageUrl) => imageUrl)
      .map((imageUrl) => `/catalog/product${imageUrl}`)[0]
  );
};

const getCouponByUserMobileNumber = (
  couponType: string = "",
  authToken: string = ""
) => {
  return fetchUtil(
    `${
      process.env.NEXT_PUBLIC_GET_VALIDATE_CONSULT_COUPONS
    }/availableCoupons?mobile=${localStorage.getItem("mobile_num")}${
      couponType ? `&type=${couponType}` : ""
    }`,
    "GET",
    {},
    "",
    true,
    "",
    authToken
  );
};

export const getDiffInMinutes = (doctorAvailableSlots: string) => {
  if (doctorAvailableSlots && doctorAvailableSlots.length > 0) {
    const date1 = new Date();
    const date2 = new Date(doctorAvailableSlots);
    const diffTime = Math.abs(date1.getTime() - date2.getTime());
    const differenceInMinutes = Math.round(diffTime / (1000 * 60));
    return differenceInMinutes;
  } else {
    return 0;
  }
};
export const getAvailability = (
  nextAvailability: string,
  differenceInMinute: number,
  type: string,
  medMantraSync?: boolean,
  consultType?: string
) => {
  const isMedMantraDoctor =
    type === "consultType" &&
    consultType?.length > 0 &&
    consultType === "physical" &&
    medMantraSync
      ? true
      : false;
  const nextAvailabilityMoment = new Date(nextAvailability);
  const todayTime = new Date();
  let tomorrowTime = new Date();
  tomorrowTime.setDate(todayTime.getDate() + 1);
  var setHoursInTmrw = setHours(tomorrowTime, 6);
  var tomorrowAvailabilityTime = setMinutes(setHoursInTmrw, 0);
  const diffInHoursForTomorrowAvailabilty = differenceInMinutes(
    nextAvailabilityMoment,
    tomorrowAvailabilityTime
  );
  const gethours = nextAvailabilityMoment.getHours();
  const getminutes = nextAvailabilityMoment.getMinutes();
  const ampm = gethours >= 12 ? "PM" : "AM";
  const isAvailableTomorrow =
    diffInHoursForTomorrowAvailabilty > 0 &&
    diffInHoursForTomorrowAvailabilty < 1440;
  const isAvailableAfterTomorrow = diffInHoursForTomorrowAvailabilty >= 1440;
  const isAvailableAfterMonth =
    differenceInDays(nextAvailabilityMoment, todayTime) > 30;
  const message =
    type === "doctorInfo"
      ? "consult"
      : isMedMantraDoctor
      ? "Available"
      : "Available";
  if (differenceInMinute > 0 && differenceInMinute < 60) {
    return `${
      isMedMantraDoctor
        ? `${message} Today`
        : `${message} in ${differenceInMinute} ${
            differenceInMinute === 1 ? "min" : "mins"
          }`
    }`;
  } else if (isAvailableAfterMonth && type === "consultType") {
    // only applies for consultType
    return `${
      isMedMantraDoctor ? `Check Availability` : `Available after a month`
    }`;
  } else if (isAvailableTomorrow) {
    return type === "doctorInfo" || type === "markup" || isMedMantraDoctor
      ? `${message} tomorrow`
      : `${message} tomorrow at ${gethours}:${
          getminutes < 10 ? "0" + getminutes : getminutes
        } ${ampm}`;
  } else if (isAvailableAfterTomorrow) {
    return `${
      isMedMantraDoctor
        ? `Check Availability`
        : `${message} in ${
            differenceInDays(nextAvailabilityMoment, tomorrowAvailabilityTime) +
            1 // intentionally added + 1 as we need to consider 6 am as next day
          } days`
    }`;
  } else if (!isAvailableTomorrow && differenceInMinute >= 60) {
    return `${
      isMedMantraDoctor
        ? `${message} Today`
        : `${message} at ${gethours}:${
            getminutes < 10 ? "0" + getminutes : getminutes
          } ${ampm}`
    }`;
  } else {
    return type === "doctorInfo" ? "Book Consult" : "Available";
  }
};

export const htmlDecode = (input: any) => {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
};

export const invokePayment = (url: any) => {
  console.log("invoke Payment", {
    url,
    BusinessCenter: BusinessCenterContext,
  });
  const source =
    getUrlParam("utm_source") || sessionStorage.getItem("utm_source") || "";
  if (source !== "MSTeams") window.location.href = url;
  else {
    BusinessCenterContext.performPopupTransaction(
      url + "&utm_source=MSTeams",
      ""
    ).then((data: any) => {
      const url = htmlDecode(decodeURIComponent(data));
      window.location.href = url;
    });
  }
};
export const openPaymentPopUp = async (orderId: string) => {
  try {
    let bC = teamsBusinessConsole?.businessCenter;
    const rawToken =
      sessionStorage?.getItem("t") || localStorage?.getItem("t") || "";

    bC?.initialize(async () => {
      const isTeams = await bC.inTeams();
      const token = encodeURIComponent(rawToken);
      bC?.payments?.initiatePayment(
        `${process.env.NEXT_PUBLIC_MS_TEAMS_HOST_URL}/paymentInit.html`,
        `https://${location.hostname}${clientRoutes.juspaySSR(
          "consult",
          orderId
        )}/?utm_source=MSTeams&t=${token}&`,
        `${process.env.NEXT_PUBLIC_MS_TEAMS_HOST_URL}/paymentResolve.html`,
        (success: any) => {
          /* We are closing the payment popup manually,so it will always lead to popup failure callback */
        },

        (err: any) => {
          router.push(localStorage.getItem("msTeamsReturnUrl"));
          localStorage.removeItem("msTeamsReturnUrl");
        }
      );
    });
  } catch (e) {
    console.log("Error creating Business context: ", e);
  }
};
export const closePaymentPopup = async () => {
  try {
    let bC = teamsBusinessConsole?.businessCenter;
    localStorage.setItem("msTeamsReturnUrl", window.location.href);
    bC?.payments?.resolvePayment();
  } catch (e) {
    console.log("Error creating Business context: ", e);
  }
};
export const isMedicineOutOfStock = (medicine: MedicineProduct): boolean => {
  if (medicine && typeof medicine === "object") {
    const { dc_availability, is_in_contract } = medicine;
    return (
      (dc_availability &&
        is_in_contract &&
        typeof dc_availability === "string" &&
        typeof is_in_contract === "string" &&
        dc_availability.toLowerCase().trim() === "no" &&
        is_in_contract.toLowerCase().trim() === "no") ||
      false
    );
  }
  return false;
};

const removeGraphQLKeyword = (error: any) => {
  return error.message.replace("GraphQL error:", "");
};

const HEALTH_RECORDS_NO_DATA_FOUND =
  "You don’t have any records with us right now. Add a record to keep everything handy in one place!";

const HEALTH_RECORDS_NOTE =
  "Please note that you can share these health records with the doctor during a consult by uploading them in the consult chat room!";

const deepLinkUtil = (deepLinkPattern: string) => {
  if (
    getDeviceType() !== DEVICE_TYPE.DESKTOP &&
    !sessionStorage.getItem("deepLinkAccessed")
  ) {
    // window.location.href = `apollopatients://${deepLinkPattern}`;
    // setTimeout(() => {
    //   window.location.href = getAppStoreLink();
    // }, 1000);
    sessionStorage.setItem("deepLinkAccessed", "1");
  }
};

const isAlternateVersion = () => {
  // the below lines are written to init app in another mode variant=2 -> marketing requirements
  if (isBrowser()) {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const alternateVariant = url.searchParams.get("variant");
    return alternateVariant && alternateVariant === "2" ? true : false;
  } else {
    return false;
  }
};

export const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
};

export const getUserAgent = () => {
  function getBrowser() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "IE", version: tem[1] || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem != null) {
        return { name: "Opera", version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1],
    };
  }

  const browserDetails = getBrowser();

  if (isMobile.Android() || isMobile.iOS()) {
    sessionStorage.setItem("isUnsupportedBrowser", "true");
  } else {
    const browserCondition =
      browserDetails.name === "Chrome" ||
      (browserDetails.name === "Safari" &&
        Number(browserDetails.version) >= 14) ||
      (browserDetails.name === "Firefox" &&
        Number(browserDetails.version) >= 82) ||
      (browserDetails.name === "Opera" && Number(browserDetails.version) >= 69);
    !browserCondition
      ? sessionStorage.setItem("isUnsupportedBrowser", "true")
      : sessionStorage.setItem("isUnsupportedBrowser", "false");
  }
};

export const browserSupport = () =>
  sessionStorage.getItem("isUnsupportedBrowser") === "true";

const isPrime = (num: number) => {
  for (let i = 2; i < num; i++) if (num % i === 0) return false;
  return num > 1;
};

const isDivisibleByTwo = (num: number) => {
  return num % 2 === 0;
};

const isDivisibleByThree = (num: number) => {
  return num % 3 === 0;
};

const getSlidesToScroll = (num: number) => {
  return isPrime(num) ? 1 : isDivisibleByThree(num) ? 3 : 2;
};

const disablingActionsTimeBeforeConsultation = 16;

const foundDataIndex = (
  key: string,
  finalData: { key: string; value: any[] }[]
) => {
  return finalData.findIndex(
    (data: { key: string; value: any[] }) => data.key === key
  );
};

const sortByDays = (
  key: string,
  finalData: { key: string; value: any[] }[],
  dataExistsAt: number,
  dataObject: any[]
) => {
  const dataArray = finalData;
  if (dataArray.length || dataExistsAt === -1) {
    dataArray.push({ key, value: [dataObject] });
  } else {
    const array = dataArray[dataExistsAt].value;
    array.push(dataObject);
    dataArray[dataExistsAt].value = array;
  }
  return dataArray;
};

export const getPatientDetails = (patientDetails: CurrentPatient) => {
  const patientAge =
    new Date().getFullYear() -
    new Date(patientDetails && patientDetails.dateOfBirth).getFullYear();
  const PatientFullName = `${patientDetails?.firstName || ""} ${
    patientDetails?.lastName || ""
  }`;
  return {
    patientId: patientDetails?.id || "",
    patientName: PatientFullName,
    patientUhid: patientDetails?.uhid || "",
    patientGender: patientDetails?.gender || "",
    mobileNumber: patientDetails?.mobileNumber || "",
    patientAge: patientDetails?.dateOfBirth ? patientAge : 0,
    isConsulted: patientDetails?.isConsulted ? "Repeat" : "New",
    Relation: patientDetails?.relation || "",
  };
};

export enum HomePageEvents {
  event = "homepage_events",
  blog_section_button = "Blog section button",
  lob_button = "LOB button",
  pro_health_banner = "Pro Health Banner",
  covid_queries = "covid19 queries",
  symptom_tiles = "symptoms tiles",
  cowin_registration = "Cowin Registration",
  chat_with_us = "Chat with us",
  vaccination_queries = "Vaccination Queries",
  faq_articles = "FAQs & Articles",
  book_lab_test = "Book Lab Tests",
  view_health_record = "View Health Records",
  book_appointment = "Book Appointment with Apollo Doctors",
  buy_medicines = "Buy Medicines and Essentials",
  explore_kavach = "Explore the Apollo Kavach Program",
  explore_health_life = "Explore HealthyLife",
  health_tools = "Health-tools",
  any_other_symptoms = "Any Other Symptoms",
}

export const getPatientAttributes = (data: any, ageType?: string) => {
  const {
    patientId,
    patientName,
    patientUhid,
    patientGender,
    mobileNumber,
    patientAge,
    isConsulted,
    Relation,
  } = data;
  return {
    "Patient Id": patientId,
    "Customer ID": patientId,
    "Patient name": patientName,
    "Patient UHID": patientUhid,
    "Patient gender": patientGender,
    "Patient age": ageType ? patientAge : patientAge?.toString(),
    Relation,
    "Mobile number": mobileNumber,
    User_Type: (isConsulted ? "Repeat" : "New") || "",
    URL: window.location.href,
    "Circle member": getCircleUserSubscriptions() ? "Yes" : "No",
    "Circle plan type": getCircleUserSubscriptions()?.["plan_id"] || "",
  };
};

export const getCashbackValueForProduct = (
  productCategory: string,
  price: number,
  cashbacks: any
): number => {
  if (cashbacks && cashbacks[productCategory])
    return (price * cashbacks[productCategory]) / 100;
  return 0;
};

const handleNavigationToDoctorDetail = (docValue: string, doctorId: string) => {
  const params = { ...utmEventDetails() };
  const modifiedDoctorValue: string =
    readableParam(docValue)?.substring(0, 3) !== "dr-"
      ? readableParam("dr-" + docValue)
      : readableParam(docValue);
  let modifiedUrl = clientRoutes.doctorDetails(
    readableParam(modifiedDoctorValue),
    doctorId
  );
  if (params?.token && params?.utmMobile) {
    return `${modifiedUrl}?utm_token=${
      params?.token || ""
    }&&utm_mobile_number=${params?.utmMobile || ""}`;
  } else {
    return modifiedUrl;
  }
};

export const getTestsCirclePrice = (
  diagnosticPricing: any,
  packageCalculatedMrp: number | null
) => {
  if (diagnosticPricing) {
    const availablePackages = diagnosticPricing.filter((pricing: any) => {
      let available: boolean = true;
      let todaysDate = new Date().setHours(0, 0, 0, 0);
      if (pricing.status && pricing.status.toLowerCase().trim() !== "active") {
        available = false;
      } else if (!pricing.groupPlan) {
        available = false;
      }
      return available;
    });
    const testsPriceObj: DiagnosticPricing = {
      isCircleDiscountGreater: false,
      circleMrp: 0,
      circlePrice: 0,
      allMrp: 0,
      allPrice: 0,
      actualMrp: 0,
      actualAllPrice: 0,
      discountPercentage: 0,
      couponCode: "",
      groupPlan: null,
      nonCirclePlan: null,
      cashbackText: "",
      cashbackAmount: 0,
      showDiscountPercent: null,
      showSlashedPrice: false,
    };
    if (!availablePackages || availablePackages.length === 0) {
      return testsPriceObj;
    } else {
      const copyAvailablePackages = JSON.parse(
        JSON.stringify(availablePackages)
      );
      copyAvailablePackages.forEach((pricing: any) => {
        pricing["actualMrp"] =
          pricing.actualMrp || JSON.parse(JSON.stringify(pricing.mrp));
        pricing.mrp = Math.max(packageCalculatedMrp || 0, pricing.mrp);
      });
      const promotedPackage = copyAvailablePackages.reduce(
        (previousPackage, currentPackage) => {
          const currDiscount = currentPackage
            ? getDiscount(currentPackage, true)
            : 0;
          const prevDiscount = previousPackage
            ? getDiscount(previousPackage, true)
            : 0;

          if (currDiscount > prevDiscount) {
            return currentPackage;
          } else if (
            currDiscount === prevDiscount &&
            currentPackage?.groupPlan === diagnosticPricingPackages.special
          ) {
            return currentPackage;
          } else {
            return previousPackage ? previousPackage : currentPackage;
          }
        },
        null
      );
      const allPrice = copyAvailablePackages.find(
        (pricing: any) => pricing.groupPlan === DIAGNOSTICS_GROUPPLAN.ALL
      );
      testsPriceObj.actualAllPrice = allPrice?.price;

      if (promotedPackage) {
        // Add cashback from promoted package
        const cashbackAmount = promotedPackage?.additionalCircleCashback
          ?.cashbackAmount
          ? Math.round(
              promotedPackage?.additionalCircleCashback?.cashbackAmount
            )
          : 0;
        testsPriceObj.cashbackAmount = cashbackAmount;
        testsPriceObj.cashbackText = cashbackAmount
          ? `₹${cashbackAmount} cashback`
          : "";

        testsPriceObj.discountPercentage = getDiscount(promotedPackage);
        testsPriceObj.couponCode = promotedPackage.couponCode;
        testsPriceObj.groupPlan = promotedPackage.groupPlan;
        testsPriceObj.actualMrp = promotedPackage.actualMrp;
        testsPriceObj.nonCirclePlan = promotedPackage.groupPlan;
        testsPriceObj.showDiscountPercent = promotedPackage.showDiscountPercent;
        testsPriceObj.showSlashedPrice = promotedPackage.showSlashedPrice;

        if (promotedPackage.groupPlan === DIAGNOSTICS_GROUPPLAN.CIRCLE) {
          testsPriceObj.isCircleDiscountGreater = true;
          testsPriceObj.circleMrp = promotedPackage.mrp;
          testsPriceObj.circlePrice = promotedPackage.price;
          const splPrice = copyAvailablePackages.find(
            (pricing: any) =>
              pricing.groupPlan === DIAGNOSTICS_GROUPPLAN.SPECIALDISCOUNTS
          );
          if (splPrice) {
            testsPriceObj.allMrp = splPrice?.mrp;
            testsPriceObj.allPrice = splPrice?.price;
            testsPriceObj.nonCirclePlan =
              DIAGNOSTICS_GROUPPLAN.SPECIALDISCOUNTS;
          } else {
            testsPriceObj.allMrp = allPrice?.mrp;
            testsPriceObj.allPrice = allPrice?.price;
            testsPriceObj.nonCirclePlan = DIAGNOSTICS_GROUPPLAN.ALL;
          }
        } else {
          testsPriceObj.isCircleDiscountGreater = false;
          testsPriceObj.circlePrice = 0;
          testsPriceObj.circleMrp = 0;
          testsPriceObj.allMrp = promotedPackage.mrp;
          testsPriceObj.allPrice = promotedPackage.price;
        }
      }
    }

    return testsPriceObj;
  }
  return;
};
export const getDiscount = (testsObj: any, getActualDiscount?: boolean) => {
  const discountPrice = testsObj.mrp - testsObj.price;
  if (getActualDiscount) {
    return discountPrice;
  } else if (discountPrice > 0) {
    return Math.round((discountPrice / testsObj.mrp) * 100);
  } else {
    return 0;
  }
};

export const getPatientAge = (dob: string): number => {
  if (dob) {
    const date1 = new Date();
    const date2 = new Date(dob);
    const diffTime = Math.abs(date1.getTime() - date2.getTime());
    const patientAge = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365));
    return patientAge;
  }
  return 0;
};

export const getAltTagValue = (alt: string) =>
  `${alt} - Online Doctor Consultation`;
const truncateText = (source: string, size: number) => {
  if (source) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }
};

export const renderStoreStatus = () => {
  var d = new Date();
  var date = d.getHours();
  return date >= 7 && date <= 23 ? "Open Now" : "Closed Now";
};

export const chunkizeArray = (arr: any[], len: number) => {
  let chunks = [],
    i = 0,
    n = arr.length;
  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }
  return chunks;
};

// SignIn related Variables
const INITIAL_OTP_MESSAGE =
  "Now type in the OTP sent to you for authentication";
const RESENT_OTP_MESSAGE =
  "Type in the OTP that has been resent to your mobile number";
const BLOCKED_MESSAGE =
  "You entered an incorrect OTP 3 times. Please try again after some time";

const MOBILE_NUMBER_PREFIX = "+91";
const NUM_OTP_DIGITS = 6;
const MAX_ALLOWED_ATTEMPTS = 3;
const OTP_PLACE_HOLDER = "Please enter the otp";
const RESEND_OTP_PLACE_HOLDER = "Request resend otp";
const MOBILE_OTP_VALIDATION_FAIL_MESSAGE = "This seems like a wrong number";
const MOBILE_OTP_VALIDATION_SUCCESS_MESSAGE = "OTP will be sent to this number";
const INCORRECT_OTP_TIMER_VALUE = 120;
const OTP_VALIDATION_TYPE = {
  MOBILE: "mobile",
  EMAIL: "email",
};

const Identifier = {
  Category_List_Query_Identifier: "_hqc",
  Category_Query_Details_Identifier: "_hqu",
};

export const Lab_Tests_Page_Identifier = {
  Lab_Tests_Category: "_ltc",
  Lab_Tests_Question: "_ltu",
};

export const TYPE_OF_QUERY_PAGE = {
  HEALTH_QUERY: "health-queries",
  LAB_TESTS: "lab-tests-queries",
};

export const TYPE_OF_QUESTIONNAIRE_PAGE = {
  QUESTIONNAIRE_LIST: "questions-list",
  QUESTIONNAIRE_DETAILS: "questions-detailed-page",
};

const getDateFromTimeStamp = (timeStamp: string) => {
  const timeStampValue = Number(timeStamp);
  const date = new Date(timeStampValue * 1000);
  return format(date, "dd MMM yyyy") || "";
};
export interface LatLng {
  lat: number;
  lng: number;
}

export const reloadPageOnce = () => {
  // The last "domLoading" Time //
  const currentDocumentTimestamp = new Date(
    performance.timing.domLoading
  ).getTime();
  // Current Time //
  const now = Date.now();
  // Ten Seconds //
  const tenSec = 10 * 1000;
  // Plus Ten Seconds //
  const plusTenSec = currentDocumentTimestamp + tenSec;
  if (now > plusTenSec) {
    location.reload();
  }
};

export const decodeEntities = (content: string) => _unescape(content);

export const getUrlParam = (param: string) => {
  if (isWindow()) {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    return params.get(param) || "";
  } else return "";
};

export const getCardTargetUrl = (props: any) => {
  let targetUrl = "";
  const userFromApp = isUserFromApp();

  const { type, slug, sourceUrl } = props;
  switch (type) {
    case "ARTICLE":
      targetUrl = `/blog/article${slug}`;
      break;
    case "REPORT":
      targetUrl = `/blog/article${slug}`;
      break;
    case "INFOGRAPHIC":
      targetUrl = sourceUrl || "";
      break;
    case "VISUAL STORY":
      targetUrl = sourceUrl || "";
      break;
    case "VIDEO":
      targetUrl = "";
      break;
    default:
      targetUrl = "";
  }
  targetUrl = `${targetUrl}${userFromApp ? "?user_from_device=true" : ""}`;
  return targetUrl;
};

const MILLISECONDS_IN_A_YEAR = 1000 * 60 * 60 * 24 * 365;
export const getAge = (dob: string, useDiffInYears?: boolean) => {
  if (dob?.length) {
    if (useDiffInYears) {
      return ` | ${differenceInYears(new Date(), new Date(dob))}`;
    } else {
      const date_array = dob.split("-");
      const years_elapsed =
        //@ts-ignore
        (new Date() - new Date(date_array[0], date_array[1], date_array[2])) /
        MILLISECONDS_IN_A_YEAR;
      return ` | ${Math.ceil(years_elapsed)}`;
    }
  }
  return null;
};

export const getDoctorDetails = (doctorDetails: DoctorDetails) => {
  const {
    displayName,
    specialistSingularTerm,
    id,
    fee,
    doctorfacility,
    experience,
    doctorType,
  } = doctorDetails;
  const getDoctorCity = doctorfacility.split(" ").pop() || "";
  return {
    "Doctor name": displayName || "",
    "Speciality name": specialistSingularTerm || "",
    "Doctor ID": id || "",
    "Consult fee": fee || "",
    "Doctor hospital": doctorfacility || "",
    "Doctor city": getDoctorCity,
    Experience: experience || "",
    "Doctor category": doctorType || "",
  };
};
export const isWindow = () => typeof window !== "undefined" && window.location;
export const isServer = () => typeof window !== "undefined" && window.location; //will deprecate

export const isPatternPresentInRoute = (pattern: string) => {
  return isWindow() ? location.pathname.includes(pattern) : "";
};

export const getSymptoms = (symptoms: string) => {
  const symptomsList = symptoms.split(", ");
  const structuredSymptomString = symptomsList.map((symptom: string) => {
    return _upperFirst(symptom.trim());
  });
  return structuredSymptomString.join(", ");
};

export const getDoctorAttributes = (data: any) => {
  const {
    doctorName,
    specialtyName,
    doctorId,
    consultFee,
    doctorHospital,
    doctorCity,
    hospitalAddress,
  } = data;
  return {
    "Doctor name": doctorName,
    "Specialty name": specialtyName,
    "Doctor id": doctorId,
    "Consult fee": consultFee,
    "doctor Hospital": doctorHospital,
    "Doctor city": doctorCity,
    "Hospital address": hospitalAddress,
  };
};

export const getOpeningHrs = (
  consultHours: (GetDoctorDetailsById_getDoctorDetailsById_consultHours | null)[]
) => {
  return consultHours.map((consult) => {
    const { startTime, endTime, weekDay } = consult;
    return `${dayMapping[weekDay]} ${startTime}-${endTime}`;
  });
};

export const getTimeFromTimestamp = (today: Date, slotTime: number) => {
  const hours = new Date(slotTime).getHours();
  const minutes = new Date(slotTime).getMinutes();
  const minutesFormat = minutes > 9 ? minutes : `0${minutes}`;
  return `${hours}:${minutesFormat}`;
};

export const getTwelveHour = (key: string, timeStringArray: Array<string>) => {
  const twelveHourHour =
    parseInt(timeStringArray[0], 10) > 12
      ? parseInt(timeStringArray[0], 10) - 12
      : timeStringArray[0];

  const formattedHour =
    twelveHourHour && Number(twelveHourHour) < 10
      ? `${twelveHourHour}`
      : twelveHourHour;

  const hours = parseInt(timeStringArray[0], 10);

  switch (key) {
    case "late night":
      return hours > 12
        ? `${hours - 12}:${timeStringArray[1]} pm`
        : `${hours == 0 ? "12" : hours}:${timeStringArray[1]} am`;
    default:
      return formattedHour;
  }
};

export const consultclevertapEventsInfo = (
  doctorDetail: DoctorDetailsById,
  currentPatient: CurrentPatient
) => {
  const patientAge =
    new Date().getFullYear() -
    new Date(currentPatient && currentPatient.dateOfBirth).getFullYear();
  const doctorAddressDetail =
    (doctorDetail &&
      doctorDetail.doctorHospital &&
      doctorDetail.doctorHospital[0] &&
      doctorDetail.doctorHospital[0].facility) ||
    "";
  return {
    patientName:
      (currentPatient &&
        `${currentPatient.firstName} ${currentPatient.lastName}`) ||
      "",
    PatientUhid: (currentPatient && currentPatient.uhid) || "",
    doctorName: (doctorDetail && doctorDetail.fullName) || "",
    specialtyName: (doctorDetail && doctorDetail.specialty.name) || "",
    doctorId: (doctorDetail && doctorDetail.id) || "",
    specialtyId: (doctorDetail && doctorDetail.specialty.id) || "",
    patientGender: (currentPatient && currentPatient.gender) || "",
    patientAge: (currentPatient && patientAge) || "",
    hospitalName: (doctorAddressDetail && doctorAddressDetail.name) || "",
    hospitalCity: (doctorAddressDetail && doctorAddressDetail.city) || "",
  };
};

export const structFilterUrl = (
  currentUrl: URL,
  type: string,
  typeArray: Array<string>
) => {
  currentUrl.searchParams.append(
    type,
    typeArray
      .map((typeValue: string) => typeValue.replace(/\s/g, "_"))
      .join(",")
  );
};

export const convertAvailabilityToDate = (
  availability: string[],
  dateSelectedFromFilter: string
): [string[], string] => {
  let availableNow = "";
  const availabilityArray: string[] = [];
  const today = format(new Date(), "yyyy-MM-dd");

  if (availability.length) {
    availability.forEach((value: string) => {
      value = value.toLocaleLowerCase();
      switch (value) {
        case "now":
          availableNow = format(
            subMinutes(new Date(), 330),
            "yyyy-MM-dd hh:mm"
          );
          break;
        case "today":
          availabilityArray.push(today);
          break;
        case "tomorrow":
          availabilityArray.push(
            format(add(new Date(), { days: 1 }), "yyyy-MM-dd")
          );
          break;
        case "next 3 days":
          [1, 2, 3].map((iterator) => {
            availabilityArray.push(
              format(add(new Date(), { days: iterator }), "yyyy-MM-dd")
            );
          });
          break;
        default:
          availabilityArray.push(value);
      }
    });
  } else if (dateSelectedFromFilter !== "") {
    const filterDateSelected = format(
      new Date(dateSelectedFromFilter),
      "yyyy-MM-dd"
    );
    filterDateSelected.length && availabilityArray.push(filterDateSelected);
  }
  return [availabilityArray, availableNow];
};

export const getExperienceRange = (experience: string[] | null): Range => {
  if (experience && experience.length) {
    return experience.map((experience) => {
      const expRangeMinimum = parseInt(experience.split("-")[0], 10);
      const expRangeMaximum = parseInt(experience.split("-")[1], 10);
      return { minimum: expRangeMinimum, maximum: expRangeMaximum };
    });
  } else {
    return [];
  }
};

export const getfeeRange = (fees: string[] | null): Range => {
  if (fees && fees.length) {
    return fees.map((fees) => {
      const feeRangeMinimum = parseInt(fees.split("-")[0], 10);
      const feeRangeMaximum = parseInt(fees.split("-")[1], 10);
      return { minimum: feeRangeMinimum, maximum: feeRangeMaximum };
    });
  } else {
    return [];
  }
};

const FilterOptions = [
  "doctortype",
  "experience",
  "availability",
  "fees",
  "language",
  "gender",
  "facilitytype",
  "superspecialty",
];

export const getFiltersApplied = (filterObject: SearchObject): string => {
  const filterOptionUsed = Object.keys(filterObject).filter((filterOption) => {
    const filterOptionAsString = String(filterOption).toLocaleLowerCase();
    return (
      FilterOptions.includes(filterOptionAsString) &&
      filterObject[filterOption].length
    );
  });
  return filterOptionUsed
    .map((filterKey) => `{${filterObject[filterKey]}`)
    .join(",");
};
/*
  This Function appends
  1. selected sortBy
  2. selcted doctorCategory
  3. selected city
  4 selected filters
  into query parameters
*/
export const setFilterQueryParams = (
  filterObject: SearchObject,
  doctorCategory: DOCTOR_CATEGORY,
  sortby?: string | null,
  consultMode?: ConsultMode
): URL => {
  const currentUrl = window.location.href;
  const newUrl = new URL(`${currentUrl.split("?")[0]}`);
  !isPatternPresentInRoute("-near-me") &&
    sortby &&
    newUrl.searchParams.append("sortby", sortby);
  consultMode && newUrl.searchParams.append("consultMode", consultMode);
  doctorCategory &&
    newUrl.searchParams.append("doctorCategory", doctorCategory);

  const filterOptionUsed = Object.keys(filterObject).filter((filterOption) => {
    const filterOptionAsString = String(filterOption).toLocaleLowerCase();
    return (
      FilterOptions.includes(filterOptionAsString) &&
      filterObject[filterOption].length
    );
  });

  filterOptionUsed.map((filterKey) => {
    structFilterUrl(newUrl, String(filterKey), filterObject[filterKey]);
  });
  return newUrl;
};

export const getProHealthEventDetails = (itemDetails) => {
  let hospital =
    _get(
      itemDetails,
      itemDetails?.packages[0]?.prohealthHospital,
      itemDetails?.packages[0]?.prohealthHospital.unitName
    ) || "";
  let categoryName =
    _get(itemDetails, itemDetails?.categoryName, itemDetails?.categoryName) ||
    "";
  let categoryId = _get(itemDetails, itemDetails?.id, itemDetails?.id) || "";
  let isClinic =
    _get(
      itemDetails,
      itemDetails?.packages,
      itemDetails?.packages[0]?.isClinicPackage
    ) || false;
  let city =
    _get(
      itemDetails,
      itemDetails?.packages[0]?.prohealthHospital?.prohealthCity,
      itemDetails?.packages[0]?.prohealthHospital?.prohealthCity?.cityName
    ) || "";
  let item = {
    categoryName,
    categoryId,
    city,
    hospital,
    isHospital: isClinic ? false : true,
    isClinic,
    userLoggedIn: false,
  };
  return item;
};

export const getProHealthProgramFeaturesTitle = (key: string) => {
  switch (key) {
    case "IncluDisgnostic":
      return "Diagnostic assessment of vitals and organ functions";
    case "IncluDocConsultation":
      return "Doctor Consultations";
    case "IncluPersonalizedHRA":
      return "Personalized health risk assessment";
    case "IncluAIPowered":
      return "AI - powered predictive risk scores";
    case "IncluPathWellness":
      return "Path to wellness";
    case "IncluDigitalHealthRec":
      return "Digital Health Record";
    default:
      return key;
  }
};

export const addNoFollowsToExternal = (html) => {
  /* if any external link exists in the htmls from server,
    apart from our parent domain, no follow has to be added */
  const whiteList = ["([^/]+.)?apollo247.com"];
  const str =
    '(<as*(?!.*\brel=)[^>]*)(href="https?://)((?!(?:' +
    whiteList.join("|") +
    '))[^"]+)"((?!.*\brel=)[^>]*)(?:[^>]*)>';

  return (
    html && html.replace(new RegExp(str, "igm"), '$1$2$3"$4 rel="nofollow">')
  );
};

export const getCarePlan = () => {
  const carePlan: any =
    isBrowser() && localStorage.getItem("CAREPlan")
      ? JSON.parse(localStorage.getItem("CAREPlan"))
      : {};
  return carePlan;
};

export const checkUserType = () => {
  let usertype = "No Subscription";
  const currentCircleSub = getCircleUserSubscriptions();
  if (currentCircleSub) {
    if (
      currentCircleSub?.["source_meta_data"]?.["purchase_type"] == "first_time"
    ) {
      usertype = "New";
    } else {
      usertype = "Repeat";
    }
  }
  return usertype;
};

export const checkUserCircleSubscriptionActive = (userSubscriptions: any) => {
  const apolloSubs = userSubscriptions?.APOLLO;
  const circleSubs = apolloSubs?.filter(
    (sub: any) => sub?.name === "CIRCLE PLAN"
  );
  return circleSubs && circleSubs.length > 0;
};

export const checkUserCareFirstSubscriptionActive = (
  userSubscriptions: any
) => {
  const apolloSubs = userSubscriptions?.APOLLO;
  const careFirstSubs = apolloSubs?.filter(
    (sub: any) => sub?.name === "Apollo247 CareFirst"
  );
  return careFirstSubs && careFirstSubs.length > 0;
};

export const getCircleUserSubscriptions = () => {
  const userSubscriptions: any =
    isBrowser() && localStorage.getItem("userSubscriptions")
      ? JSON.parse(localStorage.getItem("userSubscriptions"))
      : {};
  const apolloSubs = userSubscriptions?.APOLLO;
  const circleSubs = apolloSubs?.filter(
    (sub: any) => sub?.name === "CIRCLE PLAN"
  );
  const currentCircleSub =
    circleSubs &&
    Array.isArray(circleSubs) &&
    circleSubs?.length > 0 &&
    circleSubs?.[0];

  return currentCircleSub;
};

export const getCircleUserInactiveSubscriptions = () => {
  const userSubscriptions: any =
    isBrowser() && localStorage.getItem("inactiveSubscriptions")
      ? JSON.parse(localStorage.getItem("inactiveSubscriptions"))
      : {};
  const apolloSubs = userSubscriptions?.APOLLO;
  const circleSubs = apolloSubs?.filter(
    (sub: any) => sub?.name === "CIRCLE PLAN"
  );
  const expiredCircleSub =
    circleSubs &&
    Array.isArray(circleSubs) &&
    circleSubs?.length > 0 &&
    circleSubs?.[0];

  return expiredCircleSub;
};

export const getCareFirstUserType = () => {
  let userType = "New";
  const checkCareFirstSubscriptionExists = (localKey: string) => {
    const subscriptionFromLocalStorage =
      isBrowser() && localStorage.getItem(localKey)
        ? JSON.parse(localStorage.getItem(localKey))
        : [];
    const apolloSubs = subscriptionFromLocalStorage?.APOLLO;
    return (
      apolloSubs?.some((sub: any) => sub?.name === "Apollo247 CareFirst") ||
      false
    );
  };
  if (
    checkCareFirstSubscriptionExists("userSubscriptions") ||
    checkCareFirstSubscriptionExists("inactiveSubscriptions")
  ) {
    userType = "Repeat";
  }
  return userType;
};

export const failedApiEventData = (data) => {
  const {
    currentPatient,
    screenName,
    apiName,
    errorName,
    pageUrl,
    breadCrumb,
    doctorId,
  } = data;
  let eventData = {
    "Patient Name": `${currentPatient?.firstName || ""} ${
      currentPatient?.lastName || ""
    }`,
    "Patient Id": currentPatient?.id || "",
    "Patient Number": currentPatient?.mobileNumber || "",
    "Page URL": pageUrl,
    "Screen Name": screenName,
    "API Name": apiName,
    "Error Name": errorName,
  };
  if (breadCrumb) {
    eventData["Breadcrumbs"] = breadCrumb;
  }
  if (doctorId) {
    eventData["doctor Id"] = doctorId;
  }
  return eventData;
};

export const bookConsultAgainEventInfo = (appointmentDetails: any) => {
  return {
    "Doctor ID": _get(appointmentDetails, "doctorId", ""),
    "Doctor name": _get(appointmentDetails, "doctorInfo.fullName", ""),
    "Doctor category": _get(appointmentDetails, "doctorInfo.doctorType", ""),
    "Hospital city": _get(appointmentDetails, "doctorInfo.city", ""),
    "Speciality ID": _get(appointmentDetails, "doctorInfo.specialty.id", ""),
    "Speciality name": _get(
      appointmentDetails,
      "doctorInfo.specialty.name",
      ""
    ),
    "Consult ID": _get(appointmentDetails, "id", ""),
    "Appointment datetime": _get(appointmentDetails, "appointmentDateTime", ""),
    "Consult mode": _get(appointmentDetails, "appointmentType", ""),
    "Is consultstarted": _get(appointmentDetails, "isConsultStarted", false),
    "Diagnostic prescription": _get(
      appointmentDetails,
      "diagnosticPrescription.itemname",
      ""
    ),
    "Medicine prescription": _get(
      appointmentDetails,
      "medicinePrescription.medicineName",
      ""
    ),
    Prescription: _get(
      appointmentDetails,
      "medicinePrescription.medicineName",
      ""
    ),
  };
};

export const getFollowUpChatDaysLeft = (
  appointmentTime: string,
  followUpDays: number
) => {
  const followUpDaysEndDateTime = add(
    set(new Date(appointmentTime), { hours: 0, minutes: 0 }),
    { days: followUpDays }
  );
  const diffInDays = differenceInDays(followUpDaysEndDateTime, new Date());
  if (diffInDays >= 0 && isAfter(followUpDaysEndDateTime, new Date())) {
    return diffInDays + 1;
  }
  return diffInDays;
};

export const getFollowUpDays = (caseSheetList: CaseSheetType[]) => {
  const requiredCaseSheet =
    caseSheetList &&
    caseSheetList.length > 0 &&
    caseSheetList.find(
      (caseSheet: CaseSheetType | null) =>
        caseSheet && caseSheet.doctorType !== "JUNIOR"
    );
  if (requiredCaseSheet && requiredCaseSheet.followUpAfterInDays) {
    return Number(requiredCaseSheet.followUpAfterInDays);
  }
  return genericData.defaultFollowUpChatDays;
};

export const consultClevertapEventsInfo = (
  doctorDetail: DoctorDetailsById,
  currentPatient: CurrentPatient
) => {
  const patientAge =
    new Date().getFullYear() -
    new Date(currentPatient && currentPatient.dateOfBirth).getFullYear();
  const doctorAddressDetail =
    (doctorDetail &&
      doctorDetail.doctorHospital &&
      doctorDetail.doctorHospital[0] &&
      doctorDetail.doctorHospital[0].facility) ||
    "";
  return {
    "Patient name":
      (currentPatient &&
        `${currentPatient.firstName} ${currentPatient.lastName}`) ||
      "",
    "Patient UHID": (currentPatient && currentPatient.uhid) || "",
    "Doctor name": (doctorDetail && doctorDetail.fullName) || "",
    "Speciality name": (doctorDetail && doctorDetail?.specialty?.name) || "",
    "Doctor ID": (doctorDetail && doctorDetail.id) || "",
    "Speciality ID": (doctorDetail && doctorDetail?.specialty?.id) || "",
    "Patient gender": (currentPatient && currentPatient.gender) || "",
    "Patient age": (currentPatient && patientAge) || "",
    "Hospital name": (doctorAddressDetail && doctorAddressDetail.name) || "",
    "Hospital city": (doctorAddressDetail && doctorAddressDetail.city) || "",
  };
};

export const wordReplacement = (path, oldWord, newWord) => {
  return path?.hasOwnProperty("utm_source") ? newWord : oldWord;
};

export const getCommonPatientAttributes = (patientDetails: CurrentPatient) => {
  const patientAge = patientDetails?.dateOfBirth
    ? getDiagPatientAge(patientDetails)
    : "";

  return {
    "Patient Name":
      (patientDetails &&
        `${patientDetails.firstName} ${patientDetails.lastName}`) ||
      "",
    "Patient Uhid": (patientDetails && patientDetails.uhid) || "",
    "Patient Gender": (patientDetails && patientDetails.gender) || "",
    "Patient Age": (patientDetails && patientAge) || "",
  };
};

export const getDiagPricingDetails = (
  diagnosticPricing: DiagnosticPricing,
  isUserCare: boolean
) => {
  if (diagnosticPricing) {
    const {
      circlePrice,
      circleMrp,
      actualMrp,
      allMrp,
      allPrice,
      showSlashedPrice,
      showDiscountPercent,
      groupPlan,
      nonCirclePlan,
      cashbackAmount,
    } = diagnosticPricing;

    const circleDiscount =
      isUserCare &&
      circlePrice > 0 &&
      groupPlan === diagnosticPricingPackages.circle
        ? Math.round(((actualMrp - circlePrice) / actualMrp) * 100)
        : 0;

    const totalDiscount =
      isUserCare && circlePrice > 0
        ? circleMrp - circlePrice
        : allMrp - allPrice;

    const totalDiscountPercent =
      isUserCare && circlePrice > 0
        ? Math.round(((circleMrp - circlePrice) / circleMrp) * 100)
        : Math.round(((allMrp - allPrice) / allMrp) * 100);

    const eventData = {
      "Price plan": isUserCare ? groupPlan : nonCirclePlan,
      "Circle price":
        (isUserCare && circleDiscount > 0) || (!isUserCare && circlePrice > 0)
          ? circlePrice
          : "NA",
      "Discount text":
        totalDiscount > 0
          ? showDiscountPercent
            ? `${totalDiscountPercent}% off`
            : showDiscountPercent === false
            ? `save ₹${totalDiscount}`
            : "NA"
          : "NA",
      "Circle cashback": cashbackAmount,
    };
    return eventData;
  } else {
    return {};
  }
};

export const applyCouponOnCheckoutTracking = (data: any) => {
  if (typeof window !== "undefined") {
    const {
      slotTime,
      docId,
      slotType,
      price,
      specialtyName,
      specialtyId,
      docHospital,
      couponCode,
    } = data;
    try {
      const eventData = {
        ...getPatientAttributes(data, "ageNumber"),
        "Doctor ID": docId,
        "Specialty name": specialtyName,
        "Specialty ID": specialtyId,
        "Doctor Hospital": docHospital,
        "Slot time": slotTime,
        "Slot type": slotType,
        Price: price,
        "Coupon name": couponCode,
      };
      if (
        [
          clientRoutes.payOnlineClinicConsult(),
          clientRoutes.payOnlineConsult(),
        ].includes(location.pathname)
      ) {
        window.clevertap.event.push("Consult Apply coupon clicked", {
          ...eventData,
          Source: "checkout screen",
        });
      } else if (location.pathname === clientRoutes.payMedicine("consults")) {
        delete eventData["Specialty ID"];
        delete eventData["Doctor Hospital"];
        window.clevertap.event.push("Consult Apply coupon clicked ", {
          ...eventData,
          Source: "Payment mode screen",
        });
      }
    } catch (err) {
      console.log("Clevertap Err: ", err);
    }
  }
};

export const couponSelectedTracking = (data: any) => {
  if (typeof window !== "undefined") {
    const {
      slotTime,
      docId,
      slotType,
      price,
      specialtyName,
      specialtyId,
      docHospital,
      couponCodeTyped,
    } = data;
    try {
      let eventData = {
        ...getPatientAttributes(data, "ageNumber"),
        "Doctor Id": docId,
        "Specialty name": specialtyName,
        "Specialty Id": specialtyId,
        "Doctor Hospital": docHospital,
        "Slot Time": slotTime,
        "Slot Type": slotType,
        Price: price,
        "Coupon Code": couponCodeTyped,
        Source: "checkout screen",
      };
      if (
        [
          clientRoutes.payOnlineConsult(),
          clientRoutes.payOnlineClinicConsult(),
        ].includes(location.pathname)
      ) {
        // window.clevertap.event.push("Consult Coupon Code Selected", {
        //   ...eventData,
        //   Source: "checkout screen",
        // });
      } else if (location.pathname === clientRoutes.payMedicine("consults")) {
        delete eventData["Specialty Id"];
        delete eventData["Doctor Hospital"];
        eventData = {
          ...eventData,
          ...getPatientAttributes(data),
          Source: "Payment mode screen",
        };
        window.clevertap.event.push("Coupon code selected", eventData);
      }
    } catch (err) {
      console.log("Clevertap Err: ", err);
    }
  }
};

export const replaceAll = (mapObj: any, str: string) => {
  return str?.replace(
    /\[City\]|\[DoctorCount\]|\[SpecialistPlural\]|\[Specialty\]|\[HealthProblemsTypes]|\[Diseases\]|\[Locality\]/gi,
    function (matched) {
      return mapObj[matched];
    }
  );
};

export const DIAGNOSTIC_VALID_STATUS_ARRAY = [
  DIAGNOSTIC_ORDER_STATUS.PICKUP_REQUESTED,
  DIAGNOSTIC_ORDER_STATUS.PHLEBO_CHECK_IN,
  DIAGNOSTIC_ORDER_STATUS.PHLEBO_COMPLETED,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_SUBMITTED,
  DIAGNOSTIC_ORDER_STATUS.PARTIAL_DEPT_RECEIVED,
  DIAGNOSTIC_ORDER_STATUS.DEPT_RECEIVED,
  DIAGNOSTIC_ORDER_STATUS.PARTIAL_ORDER_COMPLETED,
  DIAGNOSTIC_ORDER_STATUS.ORDER_COMPLETED,
];

export const DIAGNOSTIC_SAMPLE_SUBMITTED_STATUS_ARRAY = [
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_SUBMITTED,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_COLLECTED,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_COLLECTED_IN_LAB,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_RECEIVED_IN_LAB,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_NOT_COLLECTED_IN_LAB,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_TESTED,
  DIAGNOSTIC_ORDER_STATUS.PARTIAL_DEPT_RECEIVED,
  DIAGNOSTIC_ORDER_STATUS.DEPT_RECEIVED,
];

export const DIAGNOSTIC_REPORT_GENERATED_STATUS_ARRAY = [
  DIAGNOSTIC_ORDER_STATUS.REPORT_GENERATED,
  DIAGNOSTIC_ORDER_STATUS.ORDER_COMPLETED,
  DIAGNOSTIC_ORDER_STATUS.PARTIAL_ORDER_COMPLETED,
];

export const DIAGNOSITC_PHELBO_TRACKING_STATUS = [
  DIAGNOSTIC_ORDER_STATUS.PHLEBO_CHECK_IN,
  DIAGNOSTIC_ORDER_STATUS.PHLEBO_COMPLETED,
];

export const getDiagnosticStatus = (
  status: DIAGNOSTIC_ORDER_STATUS,
  isInclusion?: boolean
) => {
  let statusString = "";
  switch (status) {
    case DIAGNOSTIC_ORDER_STATUS.ORDER_INITIATED:
      return "Order Initiated";
    case DIAGNOSTIC_ORDER_STATUS.ORDER_CANCELLED:
      return "Order Cancelled";
    case DIAGNOSTIC_ORDER_STATUS.CANCELLATION_REQUESTED:
      return "Cancellation Requested";
    case DIAGNOSTIC_ORDER_STATUS.ORDER_FAILED:
      return "Order Failed";
    case DIAGNOSTIC_ORDER_STATUS.ORDER_PLACED:
      return "Order Placed";
    case DIAGNOSTIC_ORDER_STATUS.PAYMENT_PENDING:
      return "Payment Pending";
    case DIAGNOSTIC_ORDER_STATUS.PICKUP_CONFIRMED:
      return "Pickup Confirmed";
    case DIAGNOSTIC_ORDER_STATUS.PICKUP_REQUESTED:
      return "Order Confirmed";
    case DIAGNOSTIC_ORDER_STATUS.REPORT_GENERATED:
      return "Report Generated";
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_COLLECTED:
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_RECEIVED_IN_LAB:
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_SUBMITTED:
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_COLLECTED_IN_LAB:
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_TESTED:
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_NOT_COLLECTED_IN_LAB:
      return isInclusion ? "Sample Submitted" : "Samples Received for Testing";
    case DIAGNOSTIC_ORDER_STATUS.PAYMENT_FAILED:
      return "Payment Failed";
    case DIAGNOSTIC_ORDER_STATUS.PAYMENT_SUCCESSFUL:
      return "Payment Successful";
    case DIAGNOSTIC_ORDER_STATUS.PHLEBO_COMPLETED:
      return "Sample Collected";
    case DIAGNOSTIC_ORDER_STATUS.PHLEBO_CHECK_IN:
      return "Apollo agent on the way";
    case DIAGNOSTIC_ORDER_STATUS.ORDER_RESCHEDULED:
    case DIAGNOSTIC_ORDER_STATUS.ORDER_RESCHEDULED_REQUEST:
      return "Order Rescheduled";
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_REJECTED_IN_LAB:
    case DIAGNOSTIC_ORDER_STATUS.SAMPLE_REJECTED:
      return "Sample Rejected";
    case DIAGNOSTIC_ORDER_STATUS.ORDER_COMPLETED:
      return "Order Completed";
    case DIAGNOSTIC_ORDER_STATUS.PARTIAL_ORDER_COMPLETED:
      return "Partial Order Completed";
    case DIAGNOSTIC_ORDER_STATUS.REFUND_INITIATED:
      return "Refund Initiated";
    case DIAGNOSTIC_ORDER_STATUS.PARTIAL_REFUND_INITIATED:
      return "Partial Refund Initiated";
    case DIAGNOSTIC_ORDER_STATUS.LEAD_DROPPED:
      return "Order Aborted";
    case DIAGNOSTIC_ORDER_STATUS.NEW_LEAD:
      return "Prescription Uploaded";
    case DIAGNOSTIC_ORDER_STATUS.REFUND_REQUEST_INITIATED:
      return "Refund Request Initiated";
    case DIAGNOSTIC_ORDER_STATUS.RESAMPLE_INITIATED:
      return "Resample Initiated";
    default:
      return statusString;
  }
};

export const extractPriceByGroupPlan = (
  cartItem: DiagnosticsCartItem,
  circleMembershipSelected?: boolean
): LineItems => {
  //check to determine wether the user is care member or not
  const userSubscriptions: any = localStorage.getItem("userSubscriptions")
    ? JSON.parse(localStorage.getItem("userSubscriptions"))
    : {};
  const isUserCare: boolean =
    userSubscriptions?.APOLLO?.length > 0 || circleMembershipSelected;
  const itemsPriceAndPlan: LineItems = {
    mrp: 0,
    itemId: 0,
    price: 0,
    groupPlan: DIAGNOSTICS_GROUPPLAN.ALL,
  };
  if (isUserCare && cartItem.diagnosticPricing.isCircleDiscountGreater) {
    itemsPriceAndPlan.itemId =
      typeof cartItem.itemId == "string"
        ? parseInt(cartItem.itemId)
        : cartItem.itemId;
    itemsPriceAndPlan.price = cartItem.diagnosticPricing.circlePrice;
    itemsPriceAndPlan.groupPlan = cartItem.diagnosticPricing.groupPlan;
    itemsPriceAndPlan.mrp = cartItem.diagnosticPricing.circleMrp;
  } else {
    itemsPriceAndPlan.itemId =
      typeof cartItem.itemId == "string"
        ? parseInt(cartItem.itemId)
        : cartItem.itemId;
    itemsPriceAndPlan.price = cartItem.diagnosticPricing.allPrice;
    itemsPriceAndPlan.groupPlan =
      cartItem.diagnosticPricing.groupPlan === DIAGNOSTICS_GROUPPLAN.CIRCLE
        ? cartItem.diagnosticPricing.nonCirclePlan
        : cartItem.diagnosticPricing.groupPlan;
    itemsPriceAndPlan.mrp = cartItem.diagnosticPricing.allMrp;
  }
  return itemsPriceAndPlan;
};

export const getObservationCount = (testObservation: InclusionData[]) => {
  const totalObservation =
    Array.isArray(testObservation) &&
    testObservation.reduce(
      (count, row) => count + getActiveInclusions(row?.incObservationData),
      0
    );
  return totalObservation || 1;
};

export const getDiagObservationCount = (testData: fullTestDetailData) => {
  if (testData?.drupalData?.diagnosticInclusionName?.length) {
    const totalObservation = testData.drupalData.diagnosticInclusionName.reduce(
      (count, row) => count + getActiveInclusions(row?.TestObservation),
      0
    );
    return totalObservation;
  }
  return 1;
};

export const getActiveInclusions = (
  testObservation: IncObservationData[]
): number => {
  const activeObservationsArr =
    (Array.isArray(testObservation) &&
      testObservation?.reduce((totalCount, observation: IncObservationData) => {
        if (observation?.isHeader === "No") {
          totalCount += 1;
        }
        return totalCount;
      }, 0)) ||
    0;
  return activeObservationsArr || 1;
};

export const createMappedDataForInclusions = (
  testObservation: TestObservation[]
) => {
  const newList: TestObservation[] = [];
  testObservation?.map((observation) => {
    if (
      observation?.isHeader?.toLowerCase() === "yes" ||
      !newList?.some(({ isHeader }) => isHeader?.toLowerCase() === "yes")
    ) {
      newList?.push(observation);
    } else if (newList?.[newList?.length - 1]?.sub) {
      const subList = newList?.[newList?.length - 1]?.sub;
      const alreadyExits = subList?.find(
        (item: any) => item?.observationID === observation?.observationID
      );
      if (!alreadyExits) {
        newList?.[newList?.length - 1]?.sub?.push(observation);
      }
    } else {
      newList[newList.length - 1].sub = [observation];
    }
  });
  return newList;
};

export const getTestParameterCountWithHeaders = (
  testObservation: TestObservation[]
) => {
  const manipulatedObservationData = createMappedDataForInclusions(
    testObservation
  );
  const observationCount =
    manipulatedObservationData?.reduce((count, item) => {
      count += item?.sub?.length || 1;
      return count;
    }, 0) || 0;
  return observationCount || 1;
};

export const getInclusionCountFromDiagnosticInclusions = (
  diagnosticInclusions: DiagnosticInclusions[]
) => {
  return (
    diagnosticInclusions?.reduce(
      (count, row) =>
        count + (getTestParameterCountWithHeaders(row?.TestObservation) || 1),
      0
    ) || 1
  );
};

export const getObservationArr = (testObservation: InclusionData[]) => {
  const observationArr: any =
    Array.isArray(testObservation) &&
    testObservation?.map((inclusionData: InclusionData) =>
      inclusionData?.incObservationData?.filter(
        (observationData: IncObservationData) =>
          observationData?.isHeader === "No"
      )
    );
  return flatten(observationArr);
};

export const hasLowerCase = (str: string) => {
  return /[a-z]/.test(str);
};

export const FILE_UPLOADING_FAILED = "Upload Failed. Please try again.";

export const fetchSEOData = (
  page: string,
  category: string | string[],
  city?: string
) => {
  const seoContentAPI = `${
    process.env.NEXT_PUBLIC_CMS_BASE_URL
  }/api/seo-html-content/${page}/${category}${city ? "/" + city : ""}`;
  return axios
    .get(seoContentAPI, {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_CMS_TOKEN,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response?.data?.data;
    })
    .catch((e) => {
      console.error("Failed to fetch content from CDN", e);
    });
};

export const getOrderClevertapData = (internalOrder: InternalOrder) => {
  if (internalOrder.type === JuspayPaymentType.Diagnostic) {
    const clevertapData = {
      "Item Id": [] as string[],
      "Item Name": [] as string[],
      "Item Type": [] as string[],
      "Item Price": [] as string[],
      "Patient Name": [] as string[],
      "Patient Uhid": [] as string[],
      "Patient Gender": [] as string[],
      "Patient Age": [] as number[],
    };

    internalOrder?.DiagnosticsPaymentDetails?.ordersList?.map((orderList) => {
      const patientObj = orderList?.patientObj;
      clevertapData["Patient Name"].push(
        `${patientObj?.firstName} ${patientObj?.lastName}`
      );
      clevertapData["Patient Uhid"].push(patientObj?.uhid);
      clevertapData["Patient Gender"].push(patientObj?.gender);
      clevertapData["Patient Age"].push(
        differenceInYears(new Date(), new Date(patientObj?.dateOfBirth))
      );

      orderList?.diagnosticOrderLineItems?.map((lineItem) => {
        clevertapData?.["Item Id"].push(`${lineItem?.itemId}`);
        clevertapData?.["Item Name"].push(lineItem?.diagnostics?.itemName);
        clevertapData?.["Item Price"].push(`${lineItem?.price}`);
        clevertapData?.["Item Type"]?.push(
          lineItem?.diagnostics?.inclusions?.length > 1 ? "Package" : "Test"
        );
      });
    });

    return clevertapData;
  }
};

export const RTPCR_COVID_ITEM_ID =
  process.env.NEXT_PUBLIC_LAB_TEST_RTPCR_COVID_ITEM_ID;
export const RECOMMENDED_WIDGET_TITLE =
  process.env.NEXT_PUBLIC_LAB_TEST_LISTING_RECOMMENDED_WIDGET_TITLE;
export const RECOMMENDED_LIST_WIDGET_TITLE = "Recommended For You List";
export const getDiagPatientAge = (patient: CurrentPatient): number =>
  differenceInYears(new Date(), new Date(patient?.dateOfBirth));

export const isDiagPatientUnderMinAge = (patient: CurrentPatient): boolean =>
  getDiagPatientAge(patient) < MINIMUM_AGE_FOR_DIAGNOSTIC_ORDER;

export const isRtpcrInCart = (
  diagnosticsCartItems: DiagnosticsCartItem[]
): boolean =>
  !!diagnosticsCartItems?.find(
    (cartItem) => cartItem?.itemId === RTPCR_COVID_ITEM_ID
  );

export const addSlotDuration = (slotValue: string, slotDuration: number) => {
  const parseDate = parse(slotValue, "h:mm a", new Date());
  return format(addMinutes(parseDate, slotDuration), "h:mm a");
};
export const getSlotsText = (
  startTime: string,
  slotDurationInMinutes: number,
  trimInitSuffix?: boolean
) => {
  if (slotDurationInMinutes > 0) {
    return `${
      trimInitSuffix
        ? startTime?.split(" ")?.[0]
        : `${addSlotDuration(startTime, 0)}`
    } - ${addSlotDuration(startTime, slotDurationInMinutes)}`?.toLowerCase();
  } else {
    return startTime;
  }
};

const getSlotDuration = (
  slotDateTimeInUTC: string,
  slotDurationInMinutes: number
): string => {
  return `${format(new Date(slotDateTimeInUTC), "h:mm a")} - ${format(
    addMinutes(new Date(slotDateTimeInUTC), slotDurationInMinutes),
    "h:mm a"
  )}`.toLowerCase();
};

const toTitleCase = (str: string) => {
  return str?.length
    ? str
        .toLowerCase()
        .split(" ")
        .map((word: string) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ")
    : "";
};

const getOneTapPlans = async () => {
  const url = `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/api/getpackagestobuy`;
  const response = await axios.get(url, {
    headers: {
      Authorization: process.env.NEXT_PUBLIC_CMS_TOKEN,
      "Content-Type": "application/json",
    },
  });
  const respData =
    Array.isArray(response?.data?.data) &&
    response?.data?.data?.map((plan) => {
      if (
        Array.isArray(plan?.PackagePlanDetails) &&
        plan.PackagePlanDetails.some(
          (pckgPlan) => !!pckgPlan.PackagePlanIsOneTap
        )
      )
        return plan;
    });
  const oneTapPackage = respData?.filter((data) => data);
  return oneTapPackage?.[0] || [];
};

const getOneTapPackageDetails = async (cmsIdentifier) => {
  const url2 = `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/api/getplandetail/${cmsIdentifier}`;
  const response = await axios.get(url2, {
    headers: {
      Authorization: process.env.NEXT_PUBLIC_CMS_TOKEN,
      "Content-Type": "application/json",
    },
  });

  const data = response?.data || [];
  return data;
};

export {
  toTitleCase,
  OTP_VALIDATION_TYPE,
  getDateFromTimeStamp,
  Identifier,
  // End of SignIn related Variables
  INCORRECT_OTP_TIMER_VALUE,
  MOBILE_OTP_VALIDATION_SUCCESS_MESSAGE,
  MOBILE_OTP_VALIDATION_FAIL_MESSAGE,
  RESEND_OTP_PLACE_HOLDER,
  OTP_PLACE_HOLDER,
  MOBILE_NUMBER_PREFIX,
  MAX_ALLOWED_ATTEMPTS,
  NUM_OTP_DIGITS,
  INITIAL_OTP_MESSAGE,
  RESENT_OTP_MESSAGE,
  BLOCKED_MESSAGE,
  disablingActionsTimeBeforeConsultation,
  getSlidesToScroll,
  deepLinkUtil,
  isDivisibleByTwo,
  isAlternateVersion,
  HEALTH_RECORDS_NO_DATA_FOUND,
  removeGraphQLKeyword,
  getCouponByUserMobileNumber,
  getPackOfMedicine,
  getImageUrl,
  getStoreName,
  getStatus,
  NO_SERVICEABLE_MESSAGE,
  OUT_OF_STOCK_MESSAGE,
  OUT_OF_STOCK_PINCODE_SUBTEXT,
  sortByProperty,
  locationRoutesBlackList,
  getDeviceType,
  getDeviceTypeTests,
  getPaymentMethodFullName,
  pharmaStateCodeMapping,
  customerCareNumber,
  MEDICINE_QUANTITY,
  readableParam,
  acceptedFilesNamesForFileUpload,
  MAX_FILE_SIZE_FOR_UPLOAD,
  INVALID_FILE_SIZE_ERROR,
  INVALID_FILE_TYPE_ERROR,
  SPECIAL_CHARACTER_IN_NAME_ERROR,
  toBase64,
  TAT_API_TIMEOUT_IN_MILLI_SEC,
  findAddrComponents,
  ORDER_BILLING_STATUS_STRINGS,
  getTypeOfProduct,
  kavachHelpline,
  isActualUser,
  NO_ONLINE_SERVICE,
  OUT_OF_STOCK,
  NOTIFY_WHEN_IN_STOCK,
  PINCODE_MAXLENGTH,
  SPECIALTY_DETAIL_LISTING_PAGE_SIZE,
  HOSPITAL_DETAIL_LISTING_PAGE_SIZE,
  HEALTH_RECORDS_NOTE,
  SPECIALTY_SEARCH_PAGE_SIZE,
  handleNavigationToDoctorDetail,
  truncateText,
  getMembershipObject,
  getSlotDuration,
  getOneTapPlans,
  getOneTapPackageDetails,
};

export const useClickOutside = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export const isItemExistsInCart = (
  modifyOrder: ModifyOrderIdAndItemIds,
  itemInclusions: any,
  itemId: string | number
): boolean => {
  return Object.entries(modifyOrder?.itemInclusions ?? {})?.some(
    ([, modifyOrderInclusions]) => {
      return (
        (itemInclusions?.length &&
          itemInclusions?.every((inclusion: any) =>
            modifyOrderInclusions?.includes(Number(inclusion))
          )) ||
        modifyOrderInclusions?.includes(Number(itemId))
      );
    }
  );
};

export const getInclusionIds = (
  inclusionData: DiagnosticWidgetInclusion[]
): number[] => {
  return inclusionData?.map((inclusion) => Number(inclusion?.incItemId));
};

export const validateGender = (
  patientGender: string,
  itemSpecificGender: string
): boolean => {
  return (
    itemSpecificGender?.toLowerCase() === patientGender?.toLowerCase() ||
    itemSpecificGender?.toLowerCase() === GENDER.All?.toLowerCase()
  );
};
export const getApolloFooter = () => {
  return axios
    .get(`${process.env.NEXT_PUBLIC_247_CDN_URL}/files/footerData.json`, {
      headers: {
        Accept: "*/*",
      },
    })
    .then((response) => {
      if (response?.data?.data) {
        return response.data.data;
      } else {
        return {};
      }
    })
    .catch((e) => {
      console.error(e);
      return {};
    });
};

export const checkItemsGenderType = () => {
  const { diagnosticsCartItems } = useDiagnosticsCart();
  const genderArr: string[] = diagnosticsCartItems?.map(
    (cartItem: DiagnosticsCartItem) => cartItem?.gender
  );
  const removeDuplicateGender = Array.from(new Set(genderArr));
  if (
    Array.isArray(removeDuplicateGender) &&
    removeDuplicateGender[0] !== GENDER.All &&
    removeDuplicateGender?.length === 1
  ) {
    return removeDuplicateGender[0];
  }
};
export const hideCancelRescheduleBtn = (
  orderStatus: DIAGNOSTIC_ORDER_STATUS
): boolean => {
  const statusArray = [
    DIAGNOSTIC_ORDER_STATUS.ORDER_INITIATED,
    DIAGNOSTIC_ORDER_STATUS.PICKUP_REQUESTED,
    DIAGNOSTIC_ORDER_STATUS.PAYMENT_SUCCESSFUL,
    DIAGNOSTIC_ORDER_STATUS.ORDER_PLACED,
  ];
  return statusArray.some((status) => status === orderStatus);
};

export const DIAGNOSTIC_PHLEBO_COMPLETED_STATUS_ARRAY = [
  DIAGNOSTIC_ORDER_STATUS.PHLEBO_COMPLETED,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_SUBMITTED,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_COLLECTED,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_COLLECTED_IN_LAB,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_RECEIVED_IN_LAB,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_NOT_COLLECTED_IN_LAB,
  DIAGNOSTIC_ORDER_STATUS.SAMPLE_TESTED,
];

export const isSameOrAfter = (date: string): boolean => {
  return isAfter(new Date(), new Date(date));
};

export const getFormattedString = (cta: CANCELLATION_REASONS_CTA) =>
  cta?.replace(/_/g, " ");
export const isValidUUID = (uuid: string): boolean => {
  // Regular expression to check if string is a valid UUID
  const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
  return regexExp.test(uuid);
};

export const oneTapEventDetails = (currentPatient: any) => {
  const params = new URLSearchParams(window?.location?.search);
  const utmCampaign = params?.get("utm_campaign") || "";
  const utmMedium =
    params?.get("utm_medium") || sessionStorage.getItem("utm_medium") || "";
  const utmCoupon = params?.get("utm_coupon") || "";
  const utmContent = params?.get("utm_content") || "";
  const utmSource =
    params?.get("utm_source") || sessionStorage.getItem("utm_source") || "";
  const utmTerm = params?.get("utm_term") || "";

  const patientDetails = getPatientDetails(currentPatient);
  const eventData = {
    ...getPatientAttributes(patientDetails),
    Nav_Source: utmCampaign?.length > 0 ? "campaign" : "Banner",
    utm_campaign: utmCampaign,
    utm_medium: utmMedium,
    utm_coupon: utmCoupon,
    utm_content: utmContent,
    utm_source: utmSource,
    utm_term: utmTerm,
  };
  return eventData;
};

export const validateMobileNumberWithPrefix = (checkNumber: string) => {
  const validRegex = /^(\+91)[6-9]{1}\d{9}$/;
  const isValid = validRegex.test(checkNumber);
  return isValid;
};

const decodeJwtResponse = (token) => {
  try {
    return JSON.parse(atob(token?.split(".")[1]));
  } catch (e) {
    console.error(e);
    return null;
  }
};

const handleCredentialResponse = (response) => {
  const responsePayload = decodeJwtResponse(response.credential);
  localStorage.setItem("email_CT", responsePayload.email);
  localStorage.setItem("name_CT", responsePayload.name);
  if (typeof window !== "undefined") {
    try {
      window.clevertap.profile.push({
        Site: {
          Name: localStorage.getItem("name_CT") || "",
          Email: localStorage.getItem("email_CT") || "",
        },
      });
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export const initializeGSI = () => {
  window.google.accounts.id.initialize({
    client_id: process.env.NEXT_PUBLIC_SIGN_IN_WITH_GOOGLE_CLIENT_ID,
    context: "use",
    callback: handleCredentialResponse,
  });
  window.google.accounts.id.prompt();
};

export const signInWithGoogle = () => {
  const script = document.createElement("script");
  script.src = process.env.NEXT_PUBLIC_SIGN_IN_WITH_GOOGLE_SCRIPT;
  script.onload = initializeGSI;
  script.async = true;
  document.querySelector("body").appendChild(script);
};

export const getFormatedTitle = (title: string) => {
  return title
    .split("-")
    .map(
      (item) =>
        `${item.slice(0, 1).toUpperCase()}${item.slice(1).toLowerCase()}`
    )
    .join(" ");
};

export const isProduction = () =>
  process.env.NEXT_PUBLIC_NODE_ENV === "production";

export const isOdd = (num: number) => num % 2 === 1;

export const isTestListingWithCtag = (router) => {
  try {
    const ctagsFromUrl = router.query.testlisting;

    const isTestListingWithC =
      router.asPath === clientRoutes.testListing(ctagsFromUrl);
    return { ctagsFromUrl, isTestListingWithC };
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getDoctorObject = (data) => {
  const apolloDoctors = data.filter(
    (doctor) => doctor.doctorType.toLowerCase() !== "doctor_connect"
  );
  const otherDoctors = data.filter(
    (doctor) => doctor.doctorType.toLowerCase() === "doctor_connect"
  );
  apolloDoctors.length === 0 && otherDoctors.length > 0;
  return {
    APOLLO: apolloDoctors,
    PARTNER: otherDoctors,
  };
};

export const utmEventDetails = () => {
  if (typeof window === "object") {
    const params = new URLSearchParams(window?.location?.search);
    const utmCampaign = params?.get("utm_campaign") || "NA";
    const utmMedium = params?.get("utm_medium") || "NA";
    const utmCoupon = params?.get("utm_coupon") || "NA";
    const utmContent = params?.get("utm_content") || "NA";
    const utmSource = params?.get("utm_source") || "NA";
    const utmTerm = params?.get("utm_term") || "NA";
    const source = params?.get("source") || "NA";
    const token = params.get("utm_token") || "";
    const utmMobile = params.get("utm_mobile_number");
    const circleMember = getCircleUserSubscriptions() ? "Yes" : "No";
    const circlePlanType = getCircleUserSubscriptions()?.["plan_id"] || "";

    const eventData = {
      Nav_Source: source,
      utm_campaign: utmCampaign,
      utm_medium: utmMedium,
      utm_coupon: utmCoupon,
      utm_content: utmContent,
      utm_source: utmSource,
      utm_term: utmTerm,
      token,
      utmMobile,
      circle_member: circleMember,
      circle_plan_type: circlePlanType,
    };
    return eventData;
  }
};

export const secondTohms = (timeInSecond) => {
  timeInSecond = Number(timeInSecond);
  let h = Math.floor(timeInSecond / 3600);
  let m = Math.floor((timeInSecond % 3600) / 60);
  let s = Math.floor((timeInSecond % 3600) % 60);
  if (s > 30) {
    let mmm = m + 1;
    let time = {
      hr: h,
      mm: mmm,
      sec: 0,
    };
    return time;
  } else {
    let time = {
      hr: h,
      mm: m,
      sec: s,
    };
    return time;
  }
};

export const blogHmsfunc = (data: any) => {
  let i = 0;
  for (i = 0; i < data?.length; i++) {
    data[i].durationshms = secondTohms(data[i]?.duration);
  }
  return data;
};

export const HOSPITAL_CATEGORIES_TYPES = {
  HOSPITALS: "hospitals",
  CLINICS: "clinics",
  PARTNER_CLINICS: "partnerClinics",
};

export const pageToBeRendered = {
  [HOSPITAL_CATEGORIES_TYPES.HOSPITALS]: "hospital",
  [HOSPITAL_CATEGORIES_TYPES.CLINICS]: "clinic",
  [HOSPITAL_CATEGORIES_TYPES.PARTNER_CLINICS]: "partner-clinic",
};

export const hospitalwithClinic = (facilityDetails) => {
  return clientRoutes
    .hospitalDetailPage(
      pageToBeRendered[facilityDetails?.hospitaltype].toLowerCase(),
      readableParam(facilityDetails?.name),
      facilityDetails?.hospital_id,
      readableParam(facilityDetails?.city)
    )
    .split("/")[2];
};

export const handleAppWebViewRedirection = (eventData?: any) => {
  const appData: any = {
    specialtyData: {
      id: eventData?.specId || "",
      name: eventData?.specialtydisplayName || "",
    },
    doctorId: eventData?.id,
    docName: eventData?.displayName,
    consultModeSelected:
      eventData?.consultModeSelected === ConsultMode.ONLINE
        ? "Video Consult"
        : "Hospital Visit",
  };
  (window && (window as any)).ReactNativeWebView.postMessage(
    JSON.stringify(appData)
  );
};

export const getApplicablePrice = (
  diagnosticPricing: DiagnosticPricing,
  isUserCare: boolean
) => {
  const { isCircleDiscountGreater, circlePrice, allPrice } = diagnosticPricing;
  return isUserCare && isCircleDiscountGreater && circlePrice > 0
    ? circlePrice
    : allPrice;
};

export const isDetailPage = (path: string): boolean => {
  const tdpRegEx = new RegExp("/lab-tests/");
  return tdpRegEx?.test(path);
};

export const filterPinCodeAddressFromList = (googleAPIResponse: any) => {
  const suggestionList = googleAPIResponse?.results;

  const [pinCodeAddress] = suggestionList?.filter((address: any) =>
    address?.address_components?.some((components: any) =>
      components?.types?.includes("postal_code")
    )
  );

  return pinCodeAddress?.address_components || [];
};

export const INVALID_PRISM_AUTH_TOKEN_ERROR_MESSAGE =
  "Invalid or expired AuthToken";

export const radiologyHomePage = "Homepage-Banner";
export const radiologyHomePageFromSearch = "Search";
export const radiologyHomePageFromTestListing = "TestListing";
export const isUserFromApp = () => {
  const search = isBrowser() && window?.location?.search;
  const params = new URLSearchParams(search);
  return params.get("user_from_device") === "true";
};

/**
 * Function to delete all the occurence of a key recursively in an object, for eg: __typename in a graphql API response
 *
 * @param obj Object/ Object of objects
 * @param key The key to deleted from the entire object recursively
 * @returns an Object
 */
export const removeKey = (obj: any, key: string) =>
  obj !== Object(obj)
    ? obj
    : Array.isArray(obj)
    ? obj.map((item) => removeKey(item, key))
    : Object.keys(obj)
        .filter((k) => k !== key)
        .reduce(
          (acc, x) => Object.assign(acc, { [x]: removeKey(obj[x], key) }),
          {}
        );

export const validRedirectUrlPaths = [
  clientRoutes.specialityListing(),
  clientRoutes.appointments(),
  clientRoutes.orders(),
  "/doctors/",
  "/pay-clinic-visit",
  "/pay-online-consult",
  "/order-details/",
  "/chat-room/",
  "/payments",
];

export const getAgeDiffFromCurrentDate = (dob: string) => {
  if (dob && dob.length) {
    const age = differenceInYears(new Date(), new Date(dob));
    return age;
  }
  return null;
};

export const RECORD_TYPE = {
  SELF: "self",
  SELF_247: "247self",
  APP_247: "APP247",
  CONSULTATION: "247selfConsultation",
};

const getFinalSortData = (key: string, finalData: any[], dataObject: any) => {
  const dataExistsAt = foundDataIndex(key, finalData);
  return sortByDays(key, finalData, dataExistsAt, dataObject);
};

const getConsiderDate = (type: string, dataObject: any) => {
  switch (type) {
    case "consults":
      return dataObject.patientId
        ? dataObject.appointmentDateTime
        : dataObject.date;
    case "lab-results":
      return dataObject.dateOfImmunization || dataObject.date;
    case "hospitalizations":
      return dataObject.date;
    case "insurance":
      return dataObject.startDateTime;
    case "bills":
      return dataObject.billDateTime;
    case "health-conditions":
      return dataObject.startDateTime || dataObject.recordDateTime;
    case "clinical-documents":
      const dateFormat = new Date(Number(dataObject.createddate));
      const momentFormat = format(dateFormat, "yyyy-MM-dd"); //2022-03-23
      return momentFormat;
  }
};

export const initialSortByDays = (
  type: string,
  filteredData: any[],
  toBeFinalData: { key: string; value: any[] }[]
) => {
  let finalData = toBeFinalData;
  filteredData.forEach((dataObject: any) => {
    const startDate = new Date();
    const dateToConsider = getConsiderDate(type, dataObject);
    const dateDifferenceInDays = differenceInDays(
      startDate,
      new Date(dateToConsider)
    );
    const dateDifferenceInMonths = differenceInMonths(
      startDate,
      new Date(dateToConsider)
    );
    const dateDifferenceInYears = differenceInMonths(
      startDate,
      new Date(dateToConsider)
    );

    if (dateDifferenceInYears !== 0) {
      if (dateDifferenceInYears >= 5) {
        finalData = getFinalSortData(
          "More than 5 years",
          finalData,
          dataObject
        );
      } else if (dateDifferenceInYears >= 2) {
        finalData = getFinalSortData("Past 5 years", finalData, dataObject);
      } else if (dateDifferenceInYears >= 1) {
        finalData = getFinalSortData("Past 2 years", finalData, dataObject);
      } else {
        finalData = getFinalSortData("Past 12 months", finalData, dataObject);
      }
    } else if (dateDifferenceInMonths > 1) {
      if (dateDifferenceInMonths >= 6) {
        finalData = getFinalSortData("Past 12 months", finalData, dataObject);
      } else if (dateDifferenceInMonths >= 2) {
        finalData = getFinalSortData("Past 6 months", finalData, dataObject);
      } else {
        finalData = getFinalSortData("Past 2 months", finalData, dataObject);
      }
    } else {
      if (dateDifferenceInDays < 7) {
        finalData = getFinalSortData("Past 7 days", finalData, dataObject);
      } else if (dateDifferenceInDays > 30) {
        finalData = getFinalSortData("Past 2 months", finalData, dataObject);
      } else {
        finalData = getFinalSortData("Past 30 days", finalData, dataObject);
      }
    }
  });
  return finalData;
};

export const getFileInfo = (url: string) => ({
  filename: url.split("/")?.pop(),
  fileExt: url?.split(".")?.pop(),
});

export const downloadFile = (url: any) => {
  const name = getFileInfo(url)?.filename ?? "NA";
  fetch(url)
    .then((resp) => resp.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((e) => console.log("error occured while download file", e));
};

export const getShortestDistance = (
  lat1: number,
  long1: number,
  lat2: number,
  long2: number
) => {
  const dLat = ((lat2 - lat1) * Math.PI) / 180.0;
  const dLon = ((long2 - long1) * Math.PI) / 180.0;

  // convert to radians
  lat1 = (lat1 * Math.PI) / 180.0;
  lat2 = (lat2 * Math.PI) / 180.0;

  // apply formulae
  const part1 =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
  const rad = 6371;
  const part2 = 2 * Math.asin(Math.sqrt(part1));
  return rad * part2;
};

export const isDiagOrderCancelled = (orderStatus: DIAGNOSTIC_ORDER_STATUS) => {
  return [
    DIAGNOSTIC_ORDER_STATUS.CANCELLATION_REQUESTED,
    DIAGNOSTIC_ORDER_STATUS.ORDER_CANCELLED,
    DIAGNOSTIC_ORDER_STATUS.ORDER_CANCELLED_REQUEST,
  ].includes(orderStatus);
};

export const getAppStoreLink = (
  androidStoreLink?: string,
  iosStoreLink?: string
) => {
  return navigator.appVersion.indexOf("Mac") !== -1
    ? iosStoreLink || process.env.NEXT_PUBLIC_IOS_APP_LINK
    : androidStoreLink || process.env.NEXT_PUBLIC_ANDROID_APP_LINK;
};

export const getNearestCity = (
  coordinates: ProhealthCoordinates[],
  latitude: number,
  longitude: number
) => {
  if (!coordinates?.length) return PROHEALTH_DEFAULT_CITY;

  const nearestLocation = coordinates.reduce((acc, currCoords) => {
    if (currCoords) {
      const currDistance = getShortestDistance(
        latitude,
        longitude,
        currCoords?.latitude,
        currCoords?.longitude
      );
      if (!acc) {
        return { ...currCoords, distance: currDistance };
      } else {
        const prevDistance = getShortestDistance(
          latitude,
          longitude,
          acc?.latitude,
          acc?.longitude
        );

        if (currDistance < prevDistance) {
          return { ...currCoords, distance: currDistance };
        } else {
          return { ...acc, distance: prevDistance };
        }
      }
    }
  });

  return nearestLocation?.location || PROHEALTH_DEFAULT_CITY;
};

export const getDiagTdpUrl = (
  canonicalTag: string,
  diagnosticAddress: DiagnosticAddressByPinCode,
  source?: string
) =>
  canonicalTag?.length
    ? diagnosticAddress?.cityName && diagnosticAddress?.cityID
      ? clientRoutes.testDetailsWithCity(
          canonicalTag,
          readableParam(diagnosticAddress?.cityName.toLowerCase()),
          source
        )
      : clientRoutes.testDetails(canonicalTag, source)
    : "";

export const millisecToTime = (timeStamp: string): string => {
  let ms = new Date().getTime() - Number(timeStamp);
  let seconds = Number((ms / 1000).toFixed());
  let minutes = Number((ms / (1000 * 60)).toFixed());
  let hours = Number((ms / (1000 * 60 * 60)).toFixed());
  if (seconds < 60) return seconds + " Sec ago";
  else if (minutes < 60) return minutes + " Min ago";
  else if (hours < 24) return hours + " Hrs ago";
  else return format(new Date(Number(timeStamp)), "dd MMM, yy");
};

export const healthRecordsCountFn = (
  getPhrNotifyEvent: getUserNotifyEvents_getUserNotifyEvents_phr_newRecordsCount | null
) => {
  if (getPhrNotifyEvent) {
    return (
      Number(getPhrNotifyEvent.LabTest) +
      Number(getPhrNotifyEvent.HealthCheck) +
      Number(getPhrNotifyEvent.Allergy) +
      Number(getPhrNotifyEvent.Bill) +
      Number(getPhrNotifyEvent.Hospitalization) +
      Number(getPhrNotifyEvent.Insurance) +
      Number(getPhrNotifyEvent.MedicalCondition) +
      Number(getPhrNotifyEvent.Medication) +
      Number(getPhrNotifyEvent.Prescription) +
      Number(getPhrNotifyEvent.Restriction)
    );
  } else {
    return null;
  }
};

export const roundOff = (num: number, decimalPlaces: number = 0) =>
  Number(num?.toFixed(decimalPlaces));

export const getDiagnosticListingData = (cityId: number, slugName: string) => {
  const api = getWidgetUrlForDiagnosticListingPage(cityId, slugName);
  return axios
    .get(api, {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_CMS_TOKEN,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response?.data?.data;
    });
};

export const getDoctorPricingForBookingFee = (
  doctorPricing: any,
  selectedConsultMode: any
) => {
  let filteredPricingData = [];
  if (selectedConsultMode === ConsultMode.ONLINE) {
    let isDoctorCare = doctorPricing?.filter(
      (item) =>
        item.available_to === "CARE_PLAN" &&
        item.appointment_type === ConsultMode.ONLINE
    );
    let isDoctorNotCare = doctorPricing?.filter(
      (item) =>
        item.available_to === "ALL" &&
        item.appointment_type === ConsultMode.ONLINE
    );
    filteredPricingData =
      isDoctorCare?.length > 0
        ? isDoctorCare
        : isDoctorNotCare?.length > 0
        ? isDoctorNotCare
        : [];
  } else if (selectedConsultMode === ConsultMode.PHYSICAL) {
    let isPhysicalDoc = doctorPricing?.filter(
      (item) =>
        item.available_to === "ALL" &&
        item.appointment_type === ConsultMode.PHYSICAL
    );
    filteredPricingData = isPhysicalDoc?.length > 0 ? isPhysicalDoc : [];
  }
  return {
    isBookingFeeApplicable: !filteredPricingData?.[0]?.isBookingFeeExempted
      ? true
      : false,
    bookingFee: !filteredPricingData?.[0]?.isBookingFeeExempted
      ? filteredPricingData?.[0]?.bookingFee
      : 0,
  };
};

const consultRoutes = [
  clientRoutes.specialityListing(),
  clientRoutes.hospitalsInIndia(),
  "/doctors",
  "/hospital",
  "/appointments",
  "/chat-room",
  "/pay-online-consult",
  "/pay-clinic-visit",
];

export const isConsultRoute = (currentPath: string) =>
  consultRoutes.some((each) => currentPath.includes(each));

export const getConsultStaticContent = async (setStaticContnet?: any) => {
  const staticContnet = await axios
    .get(
      `${process.env.NEXT_PUBLIC_247_CDN_URL}/${process.env.NEXT_PUBLIC_CONSULT_CONFIG_FILE}`
    )
    .then(({ data }: any) => {
      return data || {};
    });
  setStaticContnet && setStaticContnet(staticContnet || {});
  return staticContnet || {};
};

export const getUserLocation = async (
  address: string,
  setUserLocatedCity: any
) => {
  window.google &&
    (await geocodeByAddress(address)
      .then((results: any) => {
        const addressComponents = results?.[0]?.address_components;
        const cityObj =
          addressComponents?.find((addComponent: any) =>
            addComponent.types.includes("locality")
          ) ||
          addressComponents?.find((addComponent: any) =>
            addComponent.types.includes("administrative_area_level_3")
          );
        setUserLocatedCity(cityObj?.long_name || "");
        return cityObj || {};
      })
      .catch((e) => {
        console.error(e);
      }));
};

const updateSelectedPatient = (
  currentPatient: any,
  setPreSelectedPatientId: any,
  setCurrentPatient: any,
  allCurrentPatients: any,
  patientId: string,
  primaryPatients: PrimaryPatient[]
) => {
  if (allCurrentPatients?.length > 0) {
    let filteredCurrentPatient = allCurrentPatients.filter(
      (x) => x.id === patientId
    );
    if (filteredCurrentPatient?.length > 0) {
      const primaryFilteredPatient = getPrimaryPatientForPatient({
        primaryPatients,
        currentPatient: filteredCurrentPatient[0],
      });
      setPreSelectedPatientId(
        primaryFilteredPatient?.id ||
          patientId ||
          currentPatient?.patientId ||
          ""
      );
      setCurrentPatient(
        primaryFilteredPatient ||
          filteredCurrentPatient?.[0] ||
          currentPatient ||
          {}
      );
    }
  } else {
    setPreSelectedPatientId(currentPatient?.patientId || "");
    setCurrentPatient(currentPatient || {});
  }
};

export const getPrevSelectedConsultPatient = (
  doctor: DoctorDetailsById,
  currentPatient: any,
  prevConsultOrders: pastConsultData[],
  setPreSelectedPatientId?: any,
  setCurrentPatient?: any,
  allCurrentPatients?: any,
  primaryPatients?: PrimaryPatient[]
) => {
  let isUserAlreadySelectedProfile: any =
    (localStorage && localStorage.getItem("isUserSelectedProfile")) || {};
  let selectedProfile =
    isUserAlreadySelectedProfile &&
    Object.keys(isUserAlreadySelectedProfile)?.length > 0
      ? JSON.parse(isUserAlreadySelectedProfile)
      : {};

  if (prevConsultOrders?.length && Object.keys(selectedProfile)?.length === 0) {
    let sortedAppointments = [...prevConsultOrders];
    sortedAppointments = sortedAppointments?.sort((a: any, b: any) =>
      differenceInMinutes(
        new Date(b?.appointmentDateTime),
        new Date(a?.appointmentDateTime)
      )
    ) as any;
    let prevAppointmentsOfDoctor = sortedAppointments?.filter(
      (item) => item?.doctorId == doctor?.id
    );
    if (prevAppointmentsOfDoctor?.length > 0) {
      let patientId = prevAppointmentsOfDoctor?.[0]?.patientId;
      updateSelectedPatient(
        currentPatient,
        setPreSelectedPatientId,
        setCurrentPatient,
        allCurrentPatients,
        patientId,
        primaryPatients
      );
      return;
    } else {
      let patientId = sortedAppointments?.[0]?.patientId;
      updateSelectedPatient(
        currentPatient,
        setPreSelectedPatientId,
        setCurrentPatient,
        allCurrentPatients,
        patientId,
        primaryPatients
      );
      return;
    }
  }
  setPreSelectedPatientId(
    selectedProfile?.patientId || currentPatient?.patientId || ""
  );
  setCurrentPatient(selectedProfile || currentPatient || {});
  return;
};

export const getDoctorConsultPrice = ({
  doctorInfo,
  consultMode,
  isUserCircle,
  isPlatinumDoctor = false,
}: {
  doctorInfo: any;
  consultMode: ConsultMode;
  isUserCircle?: Boolean;
  isPlatinumDoctor?: Boolean;
}) => {
  const {
    doctorPricing,
    physicalConsultationFees,
    onlineConsultationFees,
    fee,
  } = doctorInfo;

  const consultFees = !isPlatinumDoctor
    ? consultMode === ConsultMode.ONLINE
      ? onlineConsultationFees
      : physicalConsultationFees
    : fee;

  const doctorFinalPricing = doctorPricing?.reduce((acc, curr) => {
    if (acc.available_to === PLAN.CARE_PLAN) {
      return acc;
    }
    if (curr.appointment_type === consultMode && curr.status === "ACTIVE") {
      return curr;
    }
    return acc;
  }, {});

  const {
    isBookingFeeExempted,
    slashed_price,
    is_cashback_enabled,
    bookingFee = 0,
    cashback_amount,
  } = doctorFinalPricing;

  const actualPrice = Number(consultFees ?? 0);
  const slashedPrice = !!is_cashback_enabled ? actualPrice : slashed_price;
  const priceBeforeBookingFee = isUserCircle ? slashedPrice : actualPrice;
  const finalPrice = isBookingFeeExempted
    ? priceBeforeBookingFee
    : bookingFee + priceBeforeBookingFee;

  return {
    finalPrice,
    slashedPrice,
    isBookingFeeExempted,
    bookingFee,
    circleCashback: cashback_amount ?? 0,
  };
};

export const generateWhatsappChatLink = (number: String, message: String) => {
  return `${WHATSAPP_CHAT_LINK}?phone=91${number}&text=${message}`;
};

export const trimToUppercaseValue = (value: String) => {
  return value?.replace(/\s/g, "")?.toUpperCase();
};

export const navSource =
  (isWindow() && location.pathname) === clientRoutes.tests()
    ? "Home page"
    : (isWindow() && location.pathname) === clientRoutes.testsCart()
    ? "Cart Page"
    : "Test Detail Page";

export const getDoctorSubTitles = (doctorDetails) => {
  let isClinicVisitAvailable = [];
  let btnSubtitle = "";
  if (doctorDetails?.buttons?.length > 0) {
    doctorDetails.buttons.map((item) => {
      if (item.button_type === ButtonTypes.BOOK_PHYSICAL_CONSULT) {
        isClinicVisitAvailable.push(item);
      }
    });
    if (isClinicVisitAvailable?.length > 0) {
      btnSubtitle = isClinicVisitAvailable?.[0]?.button_subTitle;
    }
  }
  return btnSubtitle;
};

export const getCityFromPath = (path: string) => {
  const cityString =
    path.includes("scity") ||
    path.includes("dcity") ||
    path.includes("dloc") ||
    path.includes("sloc");
  const last_index = path.toString().split("-").length - 1;
  const lastIndexOfIn = path.toString().split("-").lastIndexOf("in") + 1;
  const selectedCity = cityString
    ? path.toString().split("-").slice(lastIndexOfIn, last_index).join("-")
    : null;
  const parseCity = cityString
    ? path.toString().split("-").slice(lastIndexOfIn, last_index).join(" ")
    : null;

  return { selectedCity, parseCity };
};

export const readableString = (str: string) => str.split("_").join(" ");

export const getNearestHospital = (
  coordinates: RadiologyUnitsWithCoords[],
  latitude: number,
  longitude: number
) => {
  if (!coordinates?.length) return ["", ""];

  const nearestLocation = coordinates.reduce((acc, currCoords) => {
    if (currCoords) {
      const currDistance = getShortestDistance(
        latitude,
        longitude,
        currCoords?.lat,
        currCoords?.long
      );
      if (!acc) {
        return { ...currCoords, distance: currDistance };
      } else {
        const prevDistance = getShortestDistance(
          latitude,
          longitude,
          acc?.lat,
          acc?.long
        );

        if (currDistance < prevDistance) {
          return { ...currCoords, distance: currDistance };
        } else {
          return { ...acc, distance: prevDistance };
        }
      }
    }
  });

  return [nearestLocation?.locationId, nearestLocation?.unitId] || ["", ""];
};

export const doctorFiltersCategory = {
  Experience: "experience",
  Availability: "availability",
  Fees: "fees",
  Gender: "gender",
  Language: "language",
  Brands: "doctorType",
  Facility: "facilityType",
};

export const insuranceFiltersCategory = {
  Age: "selectedAge",
  Members: "selectedMembers",
  Cover: "selectedCoverRange",
  Rating: "selectedRatings",
  PED: "selectedPED",
  RoomRent: "selectedRoomRent",
};

export const getDiagCartConfigFromCDN = async () => {
  const CART_REVIEW_CONFIG = `${process.env.NEXT_PUBLIC_247_CDN_URL}/files/diagCartPageConfig.json`;
  try {
    const { data } = await axios.get(CART_REVIEW_CONFIG);
    return data as CartPageRespConfig;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getSectionNameOnRoute = (router) => {
  switch (router.pathname) {
    case "/health-records":
      return "Health Records";
    default:
      return null;
  }
};

export const getGlobalSMBGEventAttributes = (
  currentPatient: CurrentPatient,
  isMweb: boolean
) => {
  const patientAge = currentPatient?.dateOfBirth
    ? getDiagPatientAge(currentPatient)
    : "";

  return {
    Patient:
      (currentPatient &&
        `${currentPatient.firstName} ${currentPatient.lastName}`) ||
      "",
    UHID: (currentPatient && currentPatient.uhid) || "",
    "Mobile no": currentPatient?.mobileNumber || "",
    Age: (currentPatient && patientAge) || "",
    Gender: (currentPatient && currentPatient.gender) || "",
    Web_type: isMweb ? "Mweb" : "Dweb",
    Page: "SMBG_Static_web_page",
  };
};

export const triggerSMBGCTAClickEvent = (
  currentPatient: CurrentPatient,
  isMweb: boolean,
  ctaName: string,
  cardName: string,
  section: string
) => {
  const payload = {
    ...getGlobalSMBGEventAttributes(currentPatient, isMweb),
    CTA_name: ctaName,
    Card_name: cardName,
    Section: section,
  };
  clevertapTracking("SMBG_click_event", payload);
};

export const triggerSMBGSectionViewedEvent = (
  currentPatient: CurrentPatient,
  isMweb: boolean,
  section: SMBG_SECTION
) => {
  const payload = {
    ...getGlobalSMBGEventAttributes(currentPatient, isMweb),
    Section_viewed: section,
    Position: SMBG_SECTION_POSITION[section],
  };
  clevertapTracking("SMBG_widget_viewed", payload);
};

export const generateDocumentServicePrescriptionUrl = (
  {
    documentId,
    hashedDocumentId,
  }: { documentId: string; hashedDocumentId: string },
  authToken
) => {
  return `${
    process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_PUBLIC_URL
  }/api/v1/documents/public/${hashedDocumentId}?id=${documentId}&authToken=${btoa(
    authToken
  )}`;
};

export const newClevertapEvents = () => {
  return {
    Rank: null,
    "Filter Used": {
      "Sort by": null,
      Category: null,
      "Must have tests": null,
      "Top deals": null,
      Tests: null,
      Packages: null,
    },
  };
};

export const getPrimaryPatientForPatient = ({
  primaryPatients,
  currentPatient,
}: {
  primaryPatients: PrimaryPatient[];
  currentPatient: PrimaryPatient | Patient;
}) =>
  primaryPatients?.find(
    (primaryPatient) => primaryPatient?.uhid === currentPatient?.primaryUhid
  );

const DIAG_FALLBACK_ADDRESS: DiagnosticAddressByPinCode = {
  pinCode: "500085",
  cityID: 9,
  cityName: "",
  stateID: 0,
  stateName: "",
  latitude: 17.492737,
  longitude: 78.39656,
};

const getDiagDefaultAddressFromCDN = async () => {
  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_247_CDN_URL}/files/diagnosticDefaultAddress.json`
    );

    return data as DiagnosticAddressByPinCode;
  } catch (e) {
    console.error(
      "Error fetching diagnosticDefaultAddress.json, using fallback",
      e
    );
    return DIAG_FALLBACK_ADDRESS;
  }
};

export const getCachedDefaultDiagAddress = async (): Promise<DiagnosticAddressByPinCode> => {
  try {
    const defaultAddressFromLS: {
      data: DiagnosticAddressByPinCode;
      expiry: number;
    } =
      isBrowser() && localStorage?.getItem("diagDefaultAddress")
        ? JSON.parse(localStorage.getItem("diagDefaultAddress"))
        : null;

    if (
      !defaultAddressFromLS?.data ||
      new Date()?.getTime() > defaultAddressFromLS?.expiry
    ) {
      const defaultDataFromCDN = await getDiagDefaultAddressFromCDN();

      if (defaultDataFromCDN) {
        isBrowser() &&
          localStorage?.setItem(
            "diagDefaultAddress",
            JSON.stringify({
              data: defaultDataFromCDN,
              expiry: new Date().getTime() + CTA_CONFIG_EXPIRY,
            })
          );
        return defaultDataFromCDN;
      } else {
        return DIAG_FALLBACK_ADDRESS;
      }
    } else {
      return defaultAddressFromLS?.data;
    }
  } catch (e) {
    console.error(
      "Error in getting default diag address data, using fallback",
      e
    );
    return DIAG_FALLBACK_ADDRESS;
  }
};

export const uploadFileToStorage = async (
  client: ApolloClient<object>,
  fileType: string,
  base64FileInput: string
): Promise<string> => {
  if (fileType?.length && base64FileInput?.length && client) {
    try {
      const { data } = await client.mutate<UploadFile, UploadFileVariables>({
        mutation: UPLOAD_FILE,
        variables: { fileType, base64FileInput },
      });
      if (data?.uploadFile?.filePath?.length) {
        return data.uploadFile.filePath;
      } else {
        console.error("Error uploading file: filePath not received", data);
        return "";
      }
    } catch (e) {
      console.error("Error uploading file to storage", e);
      return "";
    }
  } else {
    return "";
  }
};
